   <template>

    <div class="">

      <b-overlay :show="show" spinner-variant="primary" spinner-large rounded="sm" style="height:100vh" variant="dark"
        id="loader">


        <b-container fluid style="padding-top: 100px;text-align:left">
          <b-row>
            <b-col cols="12 headerF">
              <HeaderConsumer />
            </b-col>
            <b-col cols="12 headerM">
              <HeaderConsumerMobile />
            </b-col>
          </b-row>

          <br>
          <b-row>
            <b-col cols="12">
              Consumer No of me : <select class="customSelect" id="consList" @change="switchConsumer()">

              </select>

            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div>
                <b-tabs content-class="mt-3" justified active>
                  <b-tab title="Update Profile" @click="showConsDetails('click')">
                    <b-card title="Update Profile" style=" box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;"
                      class="mb-2">

                      <hr />
                      <b-row>
                        <b-col col cols="6" sm="6" md="6" lg="2">
                          <span class="label">Consumer Number : </span>
                        </b-col>
                        <b-col col cols="6" sm="6" md="6" lg="3">
                          <span id="consumerNumber"> </span>
                        </b-col>
                        <b-col col cols="6" sm="6" md="6" lg="2" class="marginTop20px">
                          <span class="label">Consumer Name : </span>
                        </b-col>
                        <b-col col cols="6" sm="6" md="6" lg="3" class="marginTop20px">
                          <span id="consumerName"></span>
                        </b-col>
                      </b-row>

                      </br>
                      <b-row>
                        <b-col col cols="6" sm="6" md="6" lg="2" class="label">
                          Mobile No <span class="text-danger">*</span> :
                        </b-col>
                        <b-col col cols="6" sm="6" md="6" lg="3">
                          <b-form-input type="text" id="mobile" maxlength="10" autocomplete="off"
                            placeholder="Enter Mobile No" value="" trim>
                          </b-form-input>
                        </b-col>
                        <b-col col cols="6" sm="6" md="6" lg="2" class="label marginTop20px">
                          Email ID:
                        </b-col>
                        <b-col col cols="6" sm="6" md="6" lg="3" class="marginTop20px">
                          <b-form-input type="email" id="email" autocomplete="off" placeholder="Enter Email ID "
                            value="" trim>
                          </b-form-input>
                        </b-col>
                      </b-row>
                      <br>
                      <b-row class="align-items-center">
                        <!-- District -->
                        <b-col cols="6" sm="6" md="6" lg="2" class="label">
                          Select District <span class="text-danger">*</span> :
                        </b-col>
                        <b-col cols="6" sm="6" md="6" lg="3" id="districtContainer">
                          <!-- Dropdown will be injected here -->
                        </b-col>

                        <!-- Occupation -->
                        <b-col cols="6" sm="6" md="6" lg="2" class="label">
                          Occupation:
                        </b-col>
                        <b-col cols="6" sm="6" md="6" lg="3">
                          <b-form-select id="occupation" class="mb-3" v-model="selected">
                            <b-form-select-option value="null">Please select an option</b-form-select-option>
                            <b-form-select-option value="Govt">Govt Employee</b-form-select-option>
                            <b-form-select-option value="SemiGovt">Semi Govt Employee</b-form-select-option>
                            <b-form-select-option value="PSU">PSU Employee</b-form-select-option>
                            <b-form-select-option value="Others">Others</b-form-select-option>
                          </b-form-select>
                        </b-col>
                      </b-row>
                      <!-- <br>
                            <div id="districtContainer">
                            </div> -->
                      <br>
                      <br>
                      <b-row>
                        <b-col col cols="6" sm="3" md="3" lg="3" offset="3" offset-sm="4" offset-md="4" offset-lg="4">
                          <!-- <b-button id="updateButton" @click="sendOtp()" block squared variant="primary">
                                  UPDATE</b-button> -->
                          <b-button id="updateButton" @click="updateConsumer()" block squared variant="primary">
                            UPDATE</b-button>
                          <br>
                        </b-col>
                      </b-row>
                    </b-card>
                  </b-tab>
                  <b-tab title="Online Payment" @click="showBill()">
                    <b-card no-body class="mb-2 OnlinePaymentCardStyle">
                      <div id="consBillDiv">

                        <input id="sdCode" hidden />


                        <div id="msgDiv" style="color:#f4511e ;font-weight:600;display:none">
                          <br>
                          <span class="data" id="msg" style="padding:10px"></span>
                          </br>
                        </div>
                        <br>
                        <div id="billDiv" style="display:none">
                          <b-row>
                            <b-col cols=10 offset=1 style="background-color:#ffff;text-align:center">
                              <b-iconstack font-scale="5" animation="spin">
                                <b-icon stacked icon="circle-fill" variant="secondary"></b-icon>
                                <b-icon stacked icon="receipt" scale="0.5" variant="light"></b-icon>
                              </b-iconstack>
                            </b-col>
                          </b-row>
                          <br>
                          <b-row>
                            <b-col cols=10 offset=1 style="text-align:center;color:#757575 ;">
                              Bill Amount<br>
                              <span id="billAmt"
                                style="letter-spacing:1px;font-size:2.5rem;color:#0277bd;font-weight:900"></span>
                            </b-col>
                          </b-row>

                          <b-row>
                            <b-col cols=10 offset=1 style="text-align:center;color:#757575 ;">
                              Due Date<br>
                              <span id="dueDate"
                                style="letter-spacing:1px;font-size:1.2rem;color:#f4511e;font-weight:700"></span>
                            </b-col>
                          </b-row>
                          <br>
                          <b-row>
                            <b-col cols=10 offset="1">
                              <b-button block squared variant="primary" @click="payNow()"
                                style="width:100%;padding: 15px;">
                                PAY NOW
                              </b-button>
                            </b-col>
                          </b-row>
                        </div>
                      </div>
                      <div id="billdeskRequestDiv" fluid style="padding-top: 10px;text-align:left;display:none">
                        <b-row id="spinner" style="display:block">
                          <b-col cols=12 align="center">
                            <h3 class="">Processing Payment Request...</h3>
                            <br><br>
                            <b-spinner style="width: 10rem; height: 10rem;" variant="primary"
                              label="Spinning"></b-spinner>
                            <br><br><br>
                            <h5 style="color:red">Please do not press back or refresh button</h5>
                          </b-col>
                        </b-row>
                        <b-row id="errorDiv" style="display:none">
                          <b-col cols=12 align="center">
                            <h2 style="color:red">ERROR : transaction is already processed.</h2>
                            <br><br>
                            <b-button>Go Back</b-button>
                          </b-col>
                        </b-row>
                      </div>
                      <form :action="reqUrl" method="post" id="pgrequest" hidden>
                        <input type="" name="msg" :value="messageToSend" hidden>
                        <input type="submit" id="submit" value="submit" hidden>
                      </form>
                    </b-card>
                  </b-tab>



                  <b-tab title="Billing History" @click="getBillHistory('click')">
                    <b-card title="Consumer Bill Details" style=" box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;"
                      class="mb-2">


                      <b-table responsive :items="consumerBill" :fields="consumerBillFields">
                        <template v-slot:cell(due_amt)="data">
                          <span v-html="data.value"></span>
                        </template>
                        <template v-slot:cell(net_amt)="data">
                          <span v-html="data.value"></span>
                        </template>
                        <!-- <template v-slot:cell(link)="data">
                          <span v-html="data.value"></span>
                        </template> -->
                        <template v-slot:cell(link)="row">
                          <img
                            :src="`${$urlCommon}/assets/pdf-icon-3.png`"
                            height="32"
                            width="32"
                            style="cursor:pointer"
                          />
                          <a href="#"
                            class="ml-1"
                            @click.prevent="downloadBillEnglish(row.item.consNo, row.item.bill_no)">
                            English
                          </a>
                          |
                          <a href="#"
                            class="ml-1"
                            @click.prevent="downloadBillAssamese(row.item.consNo, row.item.bill_no)">
                            অসমীয়া
                          </a>
                        </template>
                      </b-table>
                    </b-card>
                  </b-tab>

                  <b-tab title="Payment History" @click="getPaymentHistory('click')">
                    <b-card title="Online Payment History" style="   box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;"
                      class="mb-2">


                      <!-- <b-table responsive :items="paymentHistory" :fields="paymentHistoryFields">
                        <template v-slot:cell(view_receipt)="data">
                          <span v-html="data.value"></span>
                        </template>
                      </b-table> -->
                      <b-table responsive :items="paymentHistory" :fields="paymentHistoryFields">
                        <template v-slot:cell(view_receipt)="data">
                          <a style="padding-left:40%; cursor:pointer;" @click="downloadReceipt(data.item)">
                            <img :src="`${$urlCommon}/assets/pdf-icon-3.png`" height="32" width="32" />
                          </a>
                        </template>
                      </b-table>
                    </b-card>
                  </b-tab>

                  <b-tab title="Consumption History" @click="getConsumptionHistory('click')">
                    <b-card title="Consumption History" style="   box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;"
                      class="mb-2">

                      <b-row>
                        <b-col col cols='12' sm="12" md="12" lg="6" id="chartContainer">
                          <canvas id="consumptionChart"></canvas>
                        </b-col>
                        <b-col class="marginTop" col cols='12' sm="12" md="12" lg="6">
                          <b-table responsive striped :items="consumptionHistory" :fields="consumptionHistoryFields">
                            <template v-slot:cell(view_receipt)="data">
                              <span v-html="data.value"></span>
                            </template>
                          </b-table>
                        </b-col>
                      </b-row>

                    </b-card>
                  </b-tab>



                  <b-tab title="TDS Adjustment Statement" @click="showTdsAdjustment('click')">
                    <b-card title="TDS(194Q) Adjustment Statement"
                      style="   box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;" class="mb-2">
                      <span id="tdsSpan" style="color:red;font-weight:500;font-size:1.2rem;"></span>

                      <!-- <b-table id="tdsTable" responsive :items="tdsAdjustment" :fields="tdsAdjustmentFields"
                        style="font-size:0.8rem;display:none"> -->
                      <b-table v-if="showTdsTable" responsive :items="tdsAdjustment" :fields="tdsAdjustmentFields"
                        style="font-size:0.8rem">
                        <template v-slot:cell(challan_link)="data">
                          <span v-html="data.value"></span>
                        </template>
                      </b-table>
                    </b-card>
                  </b-tab>

                  <b-tab title="Net Metering Profile" @click="handleNetMeteringClick">
                    <div id="mainDiv" v-show="showNetProfile">
                      <b-card v-show="showCardNormal" title="Net Metering Profile"
                        style=" box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;" class="mb-2">
                        <hr />
                        <b-row>
                          <b-col cols="12" md="3" lg="3" class="label">
                            Is PM Surya Ghar Beneficiary? <span class="text-danger">*</span>
                          </b-col>

                          <b-col cols="12" md="6" lg="6">

                            <div class="d-flex align-items-center">

                              <!-- YES OPTION -->
                              <div class="d-flex align-items-center mr-4">
                                <b-form-radio v-model="isBeneficiary" value="YES" @change="handleBeneficiaryChange">
                                  Yes
                                </b-form-radio>

                                <span v-if="isBeneficiary === 'YES'" class="ml-2 px-2 py-1 text-white font-weight-bold"
                                  style="background-color:#28a745; border-radius:15px; font-size:12px;">
                                  Net Meter
                                </span>
                              </div>

                              <!-- NO OPTION -->
                              <div class="d-flex align-items-center">
                                <b-form-radio v-model="isBeneficiary" value="NO" @change="handleBeneficiaryChange">
                                  No
                                </b-form-radio>

                                <span v-if="isBeneficiary === 'NO'" class="ml-2 px-2 py-1 text-white font-weight-bold"
                                  style="background-color:#dc3545; border-radius:15px; font-size:12px;">
                                  EXIM Meter
                                </span>
                              </div>

                            </div>

                            <!-- Highlight message (only when nothing selected) -->
                            <div v-if="!isBeneficiary" class="d-inline-block mt-2 px-3 py-1 font-weight-bold text-white"
                              style="background-color:#8B0000; border-radius:4px;">
                              Please select an option to proceed
                            </div>

                          </b-col>
                        </b-row>
                        </br>
                        <div v-show="isBeneficiary">
                          <b-row>
                            <b-col col cols="6" sm="6" md="6" lg="2">
                              <span class="label">Consumer Number : </span>
                            </b-col>
                            <b-col col cols="6" sm="6" md="6" lg="3">
                              <span id="NetConsumerNumber"> </span>
                            </b-col>
                            <b-col col cols="6" sm="6" md="6" lg="2" class="marginTop20px">
                              <span class="label">Consumer Name : </span>
                            </b-col>
                            <b-col col cols="6" sm="6" md="6" lg="3" class="marginTop20px">
                              <span id="NetConsumerName"></span>
                            </b-col>
                          </b-row>
                          </br>
                          <b-row>
                            <b-col col cols="6" sm="6" md="6" lg="2">
                              <span class="label">Mobile Number : </span>
                            </b-col>
                            <b-col col cols="6" sm="6" md="6" lg="3">
                              <span id="NetMobile"> </span>
                            </b-col>
                            <b-col col cols="6" sm="6" md="6" lg="2">
                              <span class="label">Address : </span>
                            </b-col>
                            <b-col col cols="6" sm="6" md="6" lg="3">
                              <span id="NetAddress"> </span>
                            </b-col>
                          </b-row>
                          <br>
                          <br>
                          <b-row>
                            <b-col col cols="12" sm="12" md="6" lg="4" class="label ">
                              <span class="label"> PM Surya Ghar/ Rodalee Application Number </span><span
                                class="text-danger">*</span> :
                            </b-col>
                            <b-col col cols="12" sm="12" md="6" lg="5">
                              <b-form-input type="text" maxlength="60" id="NetApplicationNo"
                                v-model.trim="NetApplicationNo" oninput="this.value = this.value.toUpperCase()"
                                placeholder="Enter Application Number" trim>
                              </b-form-input>
                            </b-col>
                          </b-row>
                          <br>
                          <br>
                          <b-row>
                            <b-col col cols="12" sm="12" md="6" lg="4">
                              <span class="label">PM Surya Ghar/ Rodalee Application Date <span
                                  class="text-danger">*</span>:</span>
                            </b-col>
                            <b-col col cols="12" sm="12" md="6" lg="5">
                              <b-form-input type="date" id="NetApplDate" v-model.trim="NetApplDate" autocomplete="off"
                                placeholder="Enter Application Date" value="" trim>
                              </b-form-input>
                            </b-col>
                          </b-row>
                          <br>
                          <br>
                          <b-row>
                            <b-col col cols="12" sm="12" md="6" lg="4" class="label ">
                              Installed Capacity of the solar unit in kWp<span class="text-danger">*</span>:
                            </b-col>
                            <b-col col cols="12" sm="12" md="6" lg="5">
                              <b-form-input type="number" maxlength="20" id="NetCapacity" v-model.trim="NetCapacity"
                                placeholder=" Installed Capacity in kWp" trim @blur="formatCapacity">
                              </b-form-input>
                            </b-col>
                          </b-row>
                          <br><br>
                          <div v-if="isBeneficiary === 'NO'">
                            <b-row>
                              <b-col col cols="12" sm="12" md="6" lg="4" class="label ">
                                <span class="label"> Location of Agreement <span class="text-danger">*</span>:</span>
                              </b-col>
                              <b-col col cols="12" sm="12" md="6" lg="5">
                                <b-form-input type="text" maxlength="60" id="NetLocation" v-model.trim="NetLocation"
                                  oninput="this.value = this.value.toUpperCase() "
                                  placeholder="Enter location of agreement" trim>
                                </b-form-input>
                              </b-col>
                            </b-row>
                            <br>
                            <br>
                            <b-row>
                              <b-col col cols="12" sm="12" md="6" lg="4" class="label ">
                                <span class="label"> Name of Witness (Vendor):</span> <span class="text-danger">*</span>
                              </b-col>
                              <b-col col cols="12" sm="12" md="6" lg="5">
                                <b-form-input type="text" v-model="inputValue" @keydown="preventNumbers" maxlength="30"
                                  id="NetWitness" oninput="this.value = this.value.toUpperCase() "
                                  v-model.trim="NetWitness" placeholder="Enter Witness Name" trim>
                                </b-form-input>
                              </b-col>
                            </b-row>
                            <br><br>
                            <b-row>
                              <b-col col cols="12" sm="12" md="6" lg="4" class="label ">
                                <label for="consumerSignatureUpload">Select Consumer Signature
                                  <span class="text-danger">*</span>:
                                  <b-icon-info-circle class="ml-2" style="cursor: pointer;"
                                    v-b-popover.hover="'File size: 10KB-50KB. Dimensions: 150x100px. Formats: JPG/JPEG.'"></b-icon-info-circle>
                                </label>
                              </b-col>
                              <b-col col cols="12" sm="12" md="6" lg="5">
                                <b-form-file id="consumerSignatureUpload" v-model="consumerSignatureFile"
                                  placeholder="Choose a file" accept="image/*" />
                                <b-button block squared variant="secondary" v-if="consumerSignatureFile"
                                  @click="uploadSignature('consumer')" style="margin-top: 5px">
                                  Upload Consumer Signature
                                </b-button>
                              </b-col>
                              <b-col col cols="12" sm="12" md="6" lg="3" v-if="consumerSignatureImageUrl">
                                <!-- Display the uploaded Consumer Signature -->

                                <img :src="consumerSignatureImageUrl" alt="Uploaded Consumer Signature"
                                  style="max-width: 200px; max-height: 100px;" />

                              </b-col>
                            </b-row>
                            <br><br>
                            <b-row>
                              <b-col col cols="12" sm="12" md="6" lg="4" class="label ">
                                <label for="witnessSignatureUpload">Select Witness Signature
                                  <span class="text-danger">*</span>:
                                  <b-icon-info-circle class="ml-2" style="cursor: pointer;"
                                    v-b-popover.hover="'File size: 10KB-50KB. Dimensions: 150x100px. Formats: JPG/JPEG.'"></b-icon-info-circle>
                                </label></b-col>
                              <b-col col cols="12" sm="12" md="6" lg="5">
                                <b-form-file id="witnessSignatureUpload" v-model="witnessSignatureFile"
                                  placeholder="Choose a file" accept="image/*" />

                                <b-button block squared variant="secondary" v-if="witnessSignatureFile"
                                  @click="uploadSignature('witness')" style="margin-top: 5px">
                                  Upload Witness Signature
                                </b-button>
                              </b-col>

                              <!-- Display the uploaded Witness Signature -->
                              <b-col col cols="12" sm="12" md="6" lg="3" v-if="witnessSignatureImageUrl">
                                <img :src="witnessSignatureImageUrl" alt="Uploaded Witness Signature"
                                  style="max-width: 200px; max-height: 100px;" />
                              </b-col>
                            </b-row><!-- Overlay spinner (shown during file upload process) -->
                          </div>
                          <br><br>
                          <b-row>
                            <b-col col cols="6" sm="3" md="3" lg="3" offset="3" offset-sm="4" offset-md="4"
                              offset-lg="4">
                              <b-button block squared variant="primary" @click="showAcceptAgreement()"
                                style="margin-top:5px">
                                Accept
                              </b-button>
                              <br>
                            </b-col>
                          </b-row>
                        </div>
                      </b-card>
                    </div>

                    <div v-show="showAgreementProfile" id="agreementProfile">

                      <b-card title="Agreement Profile" style="box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;"
                        class="mb-2">
                        <hr />
                        <b-row>
                          <b-col col cols="6" sm="12" md="12" lg="12">
                            <div id="showComment"></div>
                          </b-col>
                        </b-row>
                        <br>
                        <b-row>
                          <b-col col cols="6" sm="3" md="3" lg="3" offset="3" offset-sm="4" offset-md="4" offset-lg="4">
                            <b-button block squared variant="primary" id="" @click="generatePdf()"> Download
                              Agreement</b-button>
                          </b-col>
                        </b-row>
                      </b-card>
                    </div>
                    <div v-show="showDataProfile" id="dataProfile">
                      <b-card title="Net Metering Profile" style="box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;"
                        class="mb-2">
                        <hr />
                        <b-row>
                          <b-col col cols="6" sm="12" md="12" lg="12">
                            <div id="showCommentNetData"></div>
                          </b-col>
                        </b-row>
                      </b-card>
                    </div>
                  </b-tab>
                  <!-- IES Energy Credential Generation -->
                  <b-tab title="Energy Credential Generation" @click="handleIesCredential">
                    <div id="mainDiv" v-show="showCredential">
                      <b-card v-show="showCardNormal" title="Energy Credential Generation"
                        style=" box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;" class="mb-2">
                        <hr />
                        <b-row>
                          <b-col col cols="6" sm="6" md="6" lg="2">
                            <span class="label">Consumer Number : </span>
                          </b-col>
                          <b-col col cols="6" sm="6" md="6" lg="3">
                            <span id="IesConsNo"> </span>
                          </b-col>
                          <b-col col cols="6" sm="6" md="6" lg="2" class="marginTop20px">
                            <span class="label">Consumer Name : </span>
                          </b-col>
                          <b-col col cols="6" sm="6" md="6" lg="3" class="marginTop20px">
                            <span id="IesConsName"></span>
                          </b-col>
                        </b-row>
                        <br>
                        <b-row class="marginTop20px">
                          <b-col cols="6" sm="6" md="6" lg="2">
                            <span class="label">Download Format :</span>
                          </b-col>

                          <b-col cols="6" sm="6" md="6" lg="3">
                            <b-form-select v-model="selectedFormat" :options="downloadOptions">
                            </b-form-select>
                          </b-col>

                          <b-col cols="12" sm="12" md="12" lg="2" class="marginTop20px">
                            <b-button variant="primary" @click="downloadCredential">
                              Download
                            </b-button>
                          </b-col>

                        </b-row>
                      </b-card>
                    </div>
                  </b-tab>
                </b-tabs>

                <div id="acceptDiv" v-show="showAcceptDiv">
                  <hr>
                  <div class="agreement-container">

                    <h3 class="center"> NET METERING / EXIM metering Connection Agreement</h3>


                    <div class="agreement-content">

                      This Agreement is made and entered into at <span class="declaration">{{ NetLocation }}</span> on
                      this <span class="declaration">{{ NetCurrentDate }} </span> , between The Eligible Consumer, by
                      the
                      name of <span class="declaration">{{ NetConsumerName }} (Consumer No:{{ NetConsumerNumber
                      }})</span>,having premise at <span class="declaration">{{ NetAddress }}</span>, as first
                      party.<br>
                      AND<br>
                      <b>Assam Power Distribution Licensee</b> (herein after called as Discom) represented by <b
                        style="text-decoration: underline;">SDE, <span class="declaration">{{ NetsubDivisionName }}
                        </span></b>, and
                      having its registered office at <b>Guwahati, Assam </b> as second party of the agreement.<br>
                      Whereas, the eligible consumer has taken the responsibility to set up or facilitate the requisite
                      Photovoltaic
                      system of capacity <span class="declaration">{{ NetCapacity }} KWp</span> and sought connectivity
                      to the Discoms
                      under NET metering/ EXIM metering arrangement
                      And whereas, the Discoms agrees to benefit the eligible consumer for the electricity generated
                      from the grid
                      Interactive SPV plant into the power system of Discoms as per conditions of the agreement and AERC
                      (Grid
                      Integrative Solar PV Systems) Regulations, 2019 as amended from time to time.<br><br>
                      <b>Both the party hereby agrees to as follows:</b><br><br>





                      <h6 class="agreement">1. Eligibility</h6>
                      <ul>
                        <li>
                          <strong>1.1</strong> Eligible consumer is required to be aware, in advance, of the standards
                          and conditions
                          his system has to meet for being integrated into the grid/distribution system.
                        </li>
                        <li>
                          <strong>1.2</strong> Eligible consumer agrees that connection of Photovoltaic system to
                          DISCOM's distribution
                          system shall be bound by requirements of state Distribution Code and/or DISCOM's conditions of
                          service.
                          The grid shall continue to perform with specified reliability, security, and quality as per
                          the Central
                          Electricity Authority Technical Standards for Connectivity of Distributed Generated Resources
                          Regulations,
                          2014 of the Central Electricity Authority as amended from time to time.
                        </li>
                        <li>
                          <strong>1.3</strong> The eligible consumer shall also agree to conform to the specifications
                          and standards
                          applicable to the solar PV systems as may be prescribed by the Ministry of New and Renewable
                          Energy Sources,
                          Govt. of India, from time to time.
                        </li>
                      </ul>
                      <br>
                      <h6 class="agreement">2. Technical and Interconnection Requirements</h6>
                      <ul>
                        <li>
                          <strong>2.1</strong> Eligible consumer agrees that he has installed or will install, prior to
                          connection of
                          the photovoltaic system to DISCOM's distribution system, an isolation device (both automatic
                          and inbuilt
                          within inverter and external manual relays) and agrees for the DISCOM to have access to and
                          operation of this,
                          if required, for repair and maintenance of the distribution system.
                        </li>
                        <li>
                          <strong>2.2</strong> Eligible consumer agrees that in case of a power outage on DISCOM's
                          system, the
                          photovoltaic system will shut down, unless special transfer and isolating capabilities have
                          been installed on
                          the photovoltaic system.
                        </li>
                        <li>
                          <strong>2.3</strong> All the equipment connected to the distribution system must be compliant
                          with relevant
                          international (IEEE/IEC) or Indian standards (BIS), and installations of electrical equipment
                          must comply with
                          Indian Electricity Rules, 1956, and Central Electricity Authority (Measures of Safety and
                          Electricity Supply)
                          Regulations, 2010.
                        </li>
                        <li>
                          <strong>2.4</strong> Eligible consumer agrees that DISCOM will specify the
                          interface/inter-connection point
                          and metering point.
                        </li>
                        <li>
                          <strong>2.5</strong> Eligible consumer agrees to adhere to the following power quality
                          measures as per
                          International or Indian standards and/or other measures provided by the Commission/DISCOM:
                          <ul>
                            <li><strong>a.</strong> <strong>Harmonic current:</strong> Harmonic current injections from
                              a generating
                              station shall not exceed the limits specified in IEEE 519.</li>
                            <li><strong>b.</strong> <strong>Synchronization:</strong> The photovoltaic system must be
                              equipped with a
                              grid frequency synchronization device.</li>
                            <li><strong>c.</strong> <strong>Voltage:</strong> The voltage-operating window should
                              minimize nuisance
                              tripping and operate within 80%-110% of the nominal connected voltage. Beyond a clearing
                              time of 2
                              seconds, the photovoltaic system must isolate itself from the grid.</li>
                            <li><strong>d.</strong> <strong>Flicker:</strong> Operating of the photovoltaic system
                              should not cause
                              voltage flicker exceeding the limits stated in IEC standards or equivalent Indian
                              standards.</li>
                            <li><strong>e.</strong> <strong>Frequency:</strong> When the distribution system frequency
                              deviates beyond
                              50.5Hz (upper limit) or 47.5Hz (lower limit), the photovoltaic system should not energize
                              the grid and
                              should shift to island mode.</li>
                            <li><strong>f.</strong> <strong>DC injection:</strong> The photovoltaic system should not
                              inject DC power
                              exceeding 0.5% of full-rated output at the interconnection point or 1% of the rated
                              inverter output
                              current under any operating conditions.</li>
                            <li><strong>g.</strong> <strong>Power factor:</strong> When the inverter output is greater
                              than 50%, a
                              lagging power factor of greater than 0.9 must operate.</li>
                            <li><strong>h.</strong> <strong>Islanding and Disconnection:</strong> The photovoltaic
                              system must
                              disconnect from the grid within the IEC-standardized time in case of voltage or frequency
                              variations.</li>
                            <li><strong>i.</strong> <strong>Overload and Overheat:</strong> The inverter must
                              automatically switch off
                              during overload or overheating and restart when normal conditions are restored.</li>
                            <li><strong>j.</strong> <strong>Paralleling device:</strong> The paralleling device of the
                              photovoltaic
                              system must withstand 220% of the nominal voltage at the interconnection point.</li>
                          </ul>
                        </li>
                        <li>
                          <strong>2.6</strong> Eligible consumer agrees to furnish all operational data (e.g., voltage,
                          frequency, and
                          breaker/isolator position) as and when required by the DISCOM and, if possible, provide
                          facilities for online
                          data transfer.
                        </li>
                        <li>
                          <strong>2.7</strong> The eligible consumer shall not use a "hybrid inverter," i.e., a solar
                          inverter with a
                          provision for feeding power to the grid.
                        </li>
                      </ul>
                      <br>
                      <h6 class="agreement">3. Safety</h6>
                      <ul>
                        <li>
                          <strong>3.1</strong> Eligible consumer shall comply with the provisions of Central Electricity
                          Authority
                          (Measures Relating to Safety and Electricity Supply) Regulations 2010 and relevant provisions
                          of the National
                          Electrical Code, particularly those related to Solar PV installations.
                        </li>
                        <li>
                          <strong>3.2</strong> Eligible consumer agrees that the design, installation, maintenance, and
                          operation of the
                          photovoltaic system must ensure safety for both the photovoltaic system and DISCOM's
                          distribution system.
                        </li>
                        <li>
                          <strong>3.3</strong> If DISCOM determines that the photovoltaic system causes damage or
                          adverse effects on
                          other consumers or DISCOM's assets, the eligible consumer must disconnect the photovoltaic
                          system immediately
                          upon direction from DISCOM and rectify the issue at their own expense before reconnection.
                        </li>
                      </ul>
                      <br>
                      <h6 class="agreement">4. Clearances and Approvals</h6>
                      <ul>
                        <li><strong>4.1</strong> The eligible consumer must obtain all necessary approvals and
                          clearances (e.g.,
                          environmental and grid connection-related) before connecting the photovoltaic system to the
                          distribution
                          system.</li>
                      </ul>
                      <br>
                      <h6 class="agreement">5. Access and Disconnection</h6>
                      <ul>
                        <li><strong>5.1</strong> DISCOM shall have access to metering equipment and disconnecting means
                          of the
                          photovoltaic system, both automatic and manual, at all times.</li>
                        <li><strong>5.2</strong> In emergencies or outages where there is no access to disconnecting
                          means, DISCOM may
                          disconnect service to the premises.</li>
                      </ul>
                      <br>
                      <h6 class="agreement">6. Liabilities</h6>
                      <ul>
                        <li>
                          <strong>6.1</strong> Eligible consumer and DISCOM will indemnify each other for damages or
                          adverse effects
                          resulting from negligence or intentional misconduct in the connection and operation of the
                          photovoltaic system
                          or DISCOM's distribution system.
                        </li>
                        <li>
                          <strong>6.2</strong> Neither DISCOM nor the eligible consumer shall be liable for indirect,
                          consequential, or
                          special damages, including loss of profit, revenue, or goodwill.
                        </li>
                        <li>
                          <strong>6.3</strong> DISCOM shall not be liable for fiscal or other incentives provided to the
                          eligible
                          consumer by the central government.
                        </li>
                      </ul>
                      <br>
                      <h6 class="agreement">7. Commercial Settlement</h6>
                      <ul>
                        <li><strong>7.1</strong> All commercial settlements under this agreement will follow the
                          regulations of the
                          Assam Electricity Regulatory Commission.</li>
                      </ul>
                      <br>
                      <h6 class="agreement">8. Connection Costs</h6>
                      <ul>
                        <li><strong>8.1</strong> The eligible consumer shall bear all costs related to setting up the
                          photovoltaic
                          system, including metering and interconnection costs, as well as modifications/upgrades to the
                          distribution
                          facilities.</li>
                        <li><strong>8.2</strong> The eligible consumer must bear the cost of interconnection equipment
                          such as isolators
                          and meters.</li>
                      </ul>
                      <br>
                      <h6 class="agreement">9. Termination</h6>
                      <ul>
                        <li><strong>9.1</strong> The eligible consumer may terminate the agreement at any time by
                          providing DISCOM with
                          90 days' prior notice.</li>
                        <li><strong>9.2</strong> DISCOM has the right to terminate the agreement with 30 days' written
                          notice if the
                          eligible consumer breaches a term and fails to remedy it within the notice period.</li>
                        <li><strong>9.3</strong> Upon termination, the eligible consumer must disconnect the
                          photovoltaic system from
                          DISCOM's distribution system to DISCOM's satisfaction.</li>
                      </ul>
                      <br>

                      <div></div>

                      <br>

                    </div> <br> <b-form-checkbox class="decl" id="checkbox-1" name="checkbox-1" value="accepted"
                      v-model="undertakingAccepted">

                      I hereby declare that the above made statements are true to the best of my knowledge and belief,
                      and that I
                      understand, any misrepresentation/misinformation shall subject myself to necessary action as
                      deemed fit and
                      proper.
                    </b-form-checkbox>
                    <br>
                    <div class="decl" style="padding-left:2vw "> In the witness, where of Mr. <span
                        class="declaration">{{ NetWitness }}
                      </span>for and on behalf of <span class="declaration">{{ NetConsumerName }} </span>(Eligible
                      consumer) and <b style="text-decoration: underline;">SDE, <span class="declaration">{{
                        NetsubDivisionName }}</span></b> for and on
                      behalf of <b>Assam Power Distribution Licensee </b>(Discom) agree to this agreement.</div>
                    <b-row>
                      <b-col cols="6" sm="6" md="6" lg="6" v-if="consumerSignatureImageUrl"> <span
                          class="decl">Signature of
                          consumer</span>
                        <img :src="consumerSignatureImageUrl" alt="Uploaded Consumer Signature"
                          style="max-width: 150px; max-height: 100px;" />
                      </b-col>
                      <b-col cols="6" sm="6" md="6" lg="6" v-if="witnessSignatureImageUrl"> <span class="decl">Signature
                          of
                          Witness</span>
                        <img :src="witnessSignatureImageUrl" alt="Uploaded Witness Signature"
                          style="max-width: 150px; max-height: 100px;" />
                      </b-col>

                    </b-row>
                    <span style="padding-right:1vw ; font-size: 14px;"> Date:<span class="declaration">{{
                      NetCurrentDate }}
                      </span></span>
                    <br>

                    <span style="padding-right:1vw; font-size: 14px;">Place: <span class="declaration">
                        {{ NetLocation }}</span></span>
                  </div>

                  <b-row>

                    <b-col col cols="12" sm="12" md="2" lg="2" offset-md="4" offset-lg="4">
                      <b-button block squared variant="primary" id="saveAgreementbutton" @click="saveAgreement()"
                        style="margin-top:2px"> Submit</b-button>

                    </b-col>

                    <b-col col cols="12" sm="12" md="2" lg="2">
                      <b-button block squared variant="danger" @click="reloadPage()" style="margin-top:2px">
                        Cancel</b-button>
                    </b-col>
                  </b-row> <br><br>



                </div>

              </div>
            </b-col>
          </b-row>

        </b-container>

      </b-overlay>
      <br>


      <b-button id="success-btn" @click="$bvModal.show('successModal')" hidden></b-button>
      <b-button id="failure-btn" @click="$bvModal.show('failureModal')" hidden></b-button>

      <b-modal id="model" centered scrollable title="ALERT !" :static="true" hide-footer>
        <span class="data" id="modalMsg" style="color:red"> </span>
        <br><br>
        <b-button style="width:8rem" variant="outline-primary" @click="closeModal()">OK</b-button>
      </b-modal>

      <!-- <b-modal id="netMeterModal" ref="netMeterModal" :hide-backdrop="false" no-close-on-backdrop no-close-on-esc centered
      title="Confirmation">
        <p>Are you a PMSGY Beneficiary?</p>

        <template #modal-footer>
          <b-button variant="success" @click="confirmYes">Yes</b-button>
          <b-button variant="danger" @click="confirmNo">No</b-button>
        </template>
      </b-modal> -->
      <b-modal id="beneficiaryModal" centered hide-footer title="Selected Meter Type">
        <div class="text-center font-weight-bold" :class="isBeneficiary === 'YES' ? 'text-success' : 'text-danger'">
          {{ beneficiaryMessage }}
        </div>

        <div class="text-center mt-3">
          <b-button variant="primary" @click="$bvModal.hide('beneficiaryModal')">
            OK
          </b-button>
        </div>
      </b-modal>

      <b-modal id="profilesuccessModal" centered scrollable title="Profile Update" hide-footer>
        <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
          <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1"
            cy="65.1" r="62.1" />
          <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round"
            stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
        </svg>
        <p class="success">Profile Successfully Updated !<br><br>
          <b-button class="btn btn-outline" variant="success" id="" @click="reloadPage()">OK</b-button>
        </p>
      </b-modal>

      <b-modal id="netAgreementsuccessModal" centered scrollable title="Save Agreement" hide-footer hide-header>
        <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
          <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1"
            cy="65.1" r="62.1" />
          <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round"
            stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
        </svg>
        <p class="success">Agreement Successfully Uploaded !<br><br>
          <b-button class="btn btn-outline" variant="success" id="" @click="generatePdf()">OK </b-button>
        </p>
      </b-modal>
      <b-modal id="agreementSuccessModal" centered scrollable title="Save Agreement" hide-footer>
        <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
          <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1"
            cy="65.1" r="62.1" />
          <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round"
            stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
        </svg>
        <p class="success">Data Successfully Uploaded !<br><br>
          <b-button class="btn btn-outline" variant="success" id="" @click="reloadPage">OK </b-button>
        </p>
      </b-modal>
      <b-modal id="netAgreementfailureModal" centered scrollable title="Save Agreement" hide-footer hide-header>
        <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
          <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1"
            cy="65.1" r="62.1" />
          <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round"
            stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3" />
          <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round"
            stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2" />
        </svg>
        <p class="error">Agreement could not be uploaded !<br><br>
          <b-button variant="outline-primary" id="" @click="reloadPage()">OK </b-button>

        </p>
      </b-modal>
      <b-modal id="netAgreementrejectModal" centered scrollable title="Agreement Rejected" hide-footer hide-header
        backdrop="static" @click.stop.prevent>
        <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
          <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1"
            cy="65.1" r="62.1" />
          <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round"
            stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3" />
          <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round"
            stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2" />
        </svg>

        <p id="rejectedModalMsg" class="error"> Your application has been rejected. Please update the details and
          re-submit.<br><br><b-button variant="outline-primary" id="" @click="updateNetAgreement()">OK </b-button></p>
      </b-modal>

      <b-modal id="profilefailureModal" centered scrollable title="Profile Update" hide-footer>
        <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
          <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1"
            cy="65.1" r="62.1" />
          <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round"
            stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3" />
          <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round"
            stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2" />
        </svg>
        <p class="error">Profile Update Failed ! </p>

      </b-modal>



      <b-modal id="redirectModal" centered scrollable title="ALERT !" :static="true" hide-footer>
        <span class="data" id="redirectModalMsg" style="color:red"> </span>
        <br><br>
        <b-button style="width:8rem" variant="outline-info" @click="redirect()">OK</b-button>
      </b-modal>
    </div>

  </template>


<script>
import Chart from 'chart.js';
import HeaderConsumer from '@/components/HeaderConsumer.vue'
import HeaderConsumerMobile from '@/components/HeaderConsumerMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex);
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

var CryptoJS = require("crypto-js");
var checked = 0;
var thColor = '#0288d1';
var oldMob = "";
var click = [];
var accessToken = "";
var consList;
var mobile = "";
var dataToSend;
var consumerNumberGlobal = "";
var consumermobileGlobal = "";
var consumerNameGlobal = "";
var consumerAddressGlobal = "";
var subdivisionNameGlobal = "";

export default {
  name: 'ConsumerDashboard',
  components: {

    'HeaderConsumer': HeaderConsumer,
    'HeaderConsumerMobile': HeaderConsumerMobile
    //MarqueeText

  },
  data() {
    return {
      selectedFormat: null,
      downloadOptions: [
        { value: null, text: "Select Format", disabled: true },
        { value: "pdf", text: "PDF" },
        { value: "json", text: "JSON" }
      ],
      isBeneficiary: null,
      beneficiaryMessage: '',
      beneficiaryOptions: [
        { text: 'Yes', value: 'YES' },
        { text: 'No', value: 'NO' }
      ],
      isAgreementAccepted: false,
      showTdsTable: false,
      showNetProfile: true,  // Flag to show/hide Net Metering Profile
      showCredential: true,
      showAcceptDiv: false,
      showAgreementMessage: false,
      showAgreementProfile: false,
      showDataProfile: false,
      agreementMessage: '',
      districtFlag: false,
      show: false,
      show1: false,
      messageToSend: "",
      reqUrl: "",
      selected: null,
      NetConsumerNumber: "",
      NetConsumerName: "",
      NetApplicationNo: "",
      NetAddress: "",
      NetApplDate: "",
      NetCurrentDate: "",
      NetApplMonth: "",
      NetMobile: "",
      NetWitness: "",
      NetCapacity: "",
      NetLocation: "",
      undertakingAccepted: false,//checkbox in undertaking
      consumerSignatureFile: null,
      witnessSignatureFile: null,
      consumerSignatureImageUrl: null,
      witnessSignatureImageUrl: null,
      isValidConsumer: false,
      isValidWitness: false,
      isConsumerSignatureValid: false,
      isWitnessSignatureValid: false,
      inputValue: "",
      editableFields: false,
      showCardPMSGY: false,
      showCardNormal: true,
      NetsubDivisionName: "",
      activeContent: "netProfile",
      consumerBillFields: [
        { key: 'bill_no', label: 'Bill Number', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'bill_date', label: 'Bill Date', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'due_date', label: 'Due Date', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'due_amt', label: 'Due Bill Amount', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px', textAlign: 'center' } },
        { key: 'net_amt', label: 'Net Bill Amount', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px', textAlign: 'right' } },
        { key: 'link', label: 'Download', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px', textAlign: 'center' } }
      ],
      consumerBill: [],

      paymentHistoryFields: [
        { key: 'paid_bill_no', label: 'Bill Number', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'payment_date', label: 'Payment Date', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'payment_amt', label: 'Paid Amount', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'payment_mode', label: 'Payment Mode', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'tr_id', label: 'Receipt No', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'view_receipt', label: 'View', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } }
      ],
      paymentHistory: [],
      consumptionHistoryFields: [
        { key: 'meter_reading_date', label: 'Meter Reading Date', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'last_meter_reading', label: 'Last Meter Reading', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'consumption', label: 'Consumption (KWH)', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'total_days', label: 'Total Days', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } }
      ],
      consumptionHistory: [],
      consList: [],
      consDetails: [],
      tdsAdjustmentFields: [
        { key: 'sl_no', label: 'SL No', thStyle: { width: '3vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'cons_no', label: 'Consumer No', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'tan_no', label: 'TAN No', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'bill_no', label: 'Bill No', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'tds_amt', label: 'TDS Amount', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'challan_no', label: 'Challan No', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'challan_date', label: 'Challan Date', thStyle: { width: '7vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'challan_amt', label: 'Challan Amount', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'upload_date', label: 'Upload Date', thStyle: { width: '7vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'processed_flag', label: 'Processed', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'processed_date', label: 'Processed Date', thStyle: { width: '7vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } },
        { key: 'challan_link', label: 'Challan Link', thStyle: { width: '5vw', fontSize: "0.8rem", backgroundColor: thColor, color: '#ffff', border: 'solid #ffff 1px' } }

      ],
      tdsAdjustment: [],
      NetconsDetails: [],
      IRCASubdivisions: [
        "006", "025", "037", "057", "063", "080", "086", "099",
        "125", "144", "152", "158", "175", "196", "210", "226", "230"
      ],

      message: [
        "",
        "No Consumer Found for this Consumer Number",
        "No Outstanding Bill Found for this Consumer Number",
        "This Consumer Number is Blocked",
        "No Bill Found for Payment",
        "",
        "Server Busy! Kindly Try Again After Sometime.",
        "Transaction Already in Progress",
        "Error in Initiating Payment Request with Billdesk"
      ]
    }
  },

  methods:
  {
    reloadPage() {
      window.location.reload();
    },
    handleBeneficiaryChange(value) {
      if (value === 'YES') {
        this.beneficiaryMessage = 'Net Meter is selected';
      } else if (value === 'NO') {
        this.beneficiaryMessage = 'EXIM Meter is selected';
      }
      this.$nextTick(() => {
        this.$bvModal.show('beneficiaryModal');
      });
    },
    handleNetMeteringClick() {
      // this.showCardPMSGY = false;
      // this.showCardNormal = false;
      // this.$refs.netMeterModal.show();
      this.showDataProfile = false;
      this.showAgreementProfile = false;
      this.showCardNormal = true;
      this.showNetConsDetails('click');
    },
    handleIesCredential() {
      this.showCardNormal = true;
      document.getElementById("IesConsNo").innerHTML = consumerNumberGlobal;
      document.getElementById("IesConsName").innerHTML = consumerNameGlobal;
    },
    downloadCredential() {
      if (!this.selectedFormat) {
        this.$bvToast.toast("Please Select a format!", {
          title: "Danger",
          variant: "danger",
          solid: true,
        });
        return;
      }
      const data = {
        "consNo": consumerNumberGlobal,
        "docType": this.selectedFormat,
        "mobileNo": sessionStorage.getItem("mobile")
      };
      console.log("data::::" + JSON.stringify(data));
      let config = {
        method: 'post',
        url: this.$urlCommon + '/api/web/auth/ies/getConsumerDataForIES',
        headers: {
          'Authorization': accessToken,
          'Content-Type': 'application/json'
        },
        responseType: this.selectedFormat === "pdf" ? "blob" : "json",
        data: data
      }
      this.show = true;
      var parent = this;
      try {
        axios.request(config)
          .then(function (response) {
            parent.show = false;
            // console.log("response::"+response.data)
            // console.log(response.data instanceof Blob);
            if (parent.selectedFormat === "json") {

              const dataStr = JSON.stringify(response.data, null, 2);
              const blob = new Blob([dataStr], { type: "application/json" });

              const link = document.createElement("a");
              link.href = URL.createObjectURL(blob);
              link.download = "energyCredential.json";

              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              URL.revokeObjectURL(link.href);

            } else if (parent.selectedFormat === "pdf") {

              const blob = new Blob([response.data], { type: "application/pdf" });

              const link = document.createElement("a");
              link.href = URL.createObjectURL(blob);
              link.download = "energyCredential.pdf";

              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              URL.revokeObjectURL(link.href);
            }
          })
          .catch((error) => {
            console.error("API Error:", error);
          });
      } catch (error) {
        console.error("Error calling server", error.response || error);
        this.show = false;
      }
    },
    // confirmYes() {
    //   this.$refs.netMeterModal.hide();
    //   this.showCardPMSGY = true;   
    //   this.showCardNormal = false;  
    // },

    // confirmNo() {
    //   this.$refs.netMeterModal.hide();
    //   this.showCardPMSGY = false;   
    //   this.showCardNormal = true;   
    //   this.showNetConsDetails('click');
    // },

    preventNumbers(event) {
      if (event.key >= '0' && event.key <= '9') {
        event.preventDefault(); // Block numbers
      }
    },
    formatCapacity() {
      if (!this.NetCapacity) return;

      let formattedValue = this.NetCapacity.toString();

      // Allow digits & dot only
      formattedValue = formattedValue.replace(/[^0-9.]/g, '');

      // Allow only one dot
      const parts = formattedValue.split('.');
      if (parts.length > 2) {
        formattedValue = parts[0] + '.' + parts[1];
      }

      // Limit to 2 decimal places
      if (formattedValue.includes('.')) {
        const [intPart, decPart] = formattedValue.split('.');
        formattedValue = intPart + '.' + decPart.substring(0, 2);
      } else {
        formattedValue = formattedValue + '.00';
      }

      // ✅ Update Vue model (THIS is the key)
      this.NetCapacity = formattedValue;
    },
    closeModal() {
      this.$bvModal.hide('model')
    },
    reloadPage() {
      window.location.reload();
    },
    redirect() {
      sessionStorage.removeItem("accessToken");
      sessionStorage.removeItem("consList");
      sessionStorage.removeItem("selectedCons");
      window.location.href = "/website/";
      return false;
    },
    switchConsumer() {
      this.show = true;
      var consNo = document.getElementById("consList").value;

      var consType;

      var parent = this;
      let data = JSON.stringify({
        "consNo": consNo,
        "mobileNo": mobile
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: this.$urlCommon + '/api/web/auth/getConsDetails',
        headers: {
          'Authorization': accessToken,
          'Content-Type': 'application/json'
        },
        data: data
      };
      var parent = this;
      axios.request(config)
        .then((response) => {
          parent.show = false;
          // console.log(response.data);
          if (response.data.message == "00") {
            sessionStorage.setItem("selectedCons", consNo);
            consType = response.data.connType;
            if (consType == "POSTPAID") {
              window.location.href = "/website/ConsumerDashboardPostpaid";
              return false;
            }
            else if (consType == "SMART POSTPAID") {
              window.location.href = "/website/ConsumerDashboardSmartPostpaid";
              return false;
            }
            else if (consType == "PREPAID") {
              window.location.href = "/website/ConsumerDashboardPrepaid";
              return false;
            }
            else if (consType == "SMART PREPAID") {
              window.location.href = "/website/ConsumerDashboardSmartPrepaid";
              return false;
            }
          }
          else {
            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML = "Consumer Not Found";
          }
        })
        .catch((e) => {
          parent.show = false;
          console.log("Caught :::::::::::::::", e.message);
          if (e.response.data.error == "Forbidden") {
            parent.$bvModal.show('redirectModal');
            document.getElementById("redirectModalMsg").innerHTML = "Session Expired, Please log in again";
          }
        });
    },

    showBill() {

      var consNo = document.getElementById('consList').value;

      let data = JSON.stringify({
        "consNo": consNo,
        "mobileNo": mobile
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: this.$urlCommon + '/api/web/auth/consBillDetailsBilldesk',
        headers: {
          'Authorization': accessToken,
          'Content-Type': 'application/json'
        },
        data: data
      };
      var parent = this;
      this.show = true;
      axios.request(config)
        .then((response) => {
          parent.show = false;

          var data = response.data.data;
          var msg = response.data.message;
          if (msg == "00") {
            var res = data.due_date.split("-");
            var dueDate = res[2] + "-" + res[1] + "-" + res[0];
            document.getElementById("billDiv").style.display = "block";
            document.getElementById("msgDiv").style.display = "none";
            document.getElementById("sdCode").value = data.sd_code;
            document.getElementById("billAmt").innerHTML = data.due_amount + ".00";
            document.getElementById("dueDate").innerHTML = dueDate;

          }
          else {
            document.getElementById("billDiv").style.display = "none";
            document.getElementById("msgDiv").style.display = "block";
            document.getElementById("msg").innerHTML = parent.message[parseInt(msg)];

          }
        })
        .catch((e) => {
          parent.show = false;
          parent.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML = "Sorry, Please Try Again Later";
          console.log("Caught :::::::::::::::", e.message);

        })
    },
    payNow() {
      var consNo = document.getElementById("consList").value;
      var sdCode = document.getElementById("sdCode").value;

      document.getElementById("consBillDiv").style.display = "none";
      document.getElementById("billdeskRequestDiv").style.display = "block";
      var parent = this;

      function isMobile() {
        return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
      }

      if (isMobile()) {
        axios.post(this.$urlCommon + '/api/onlinepostpaid/pgrequest?consNo=' + consNo + '&subDiv=' + sdCode)
          .then((response) => {
            // console.log(response.data);
            var data = response.data;
            var status = response.data.message;

            if (status == "00") {
              parent.reqUrl = data.action;
              parent.messageToSend = data.msg;
              setTimeout(function () { document.getElementById("submit").click(); }, 2000);
            }
            else {
              document.getElementById('spinner').style.display = 'none';
              document.getElementById('errorDiv').style.display = 'block';
              document.getElementById('errorMsg').innerHTML = parent.message[parseInt(status)];
              this.$bvModal.show("model");
              document.getElementById("msg").innerHTML = parent.message[parseInt(status)];
            }
          })
          .catch((e) => {
            console.log("Caught", e);
            this.show = false;
            this.$bvModal.show("model");
            document.getElementById("msg").innerHTML = e;
            document.getElementById("BillDetails").classList.remove("showBillDetails");
          })
      }
      else {
        axios.post(this.$urlCommon + '/api/onlinepostpaid/pgrequest?consNo=' + consNo + '&subDiv=' + sdCode)
          .then((response) => {
            //console.log(response.data);
            var data = response.data;
            var msg = response.data.message;

            var reqUrl = "";
            var messageToSend = "";

            if (msg == "00") {
              reqUrl = data.action;
              messageToSend = data.msg;
              const dataToNewPage = { reqUrl: reqUrl, messageToSend: messageToSend };
              const queryString = new URLSearchParams(dataToNewPage).toString();
              window.open(`/website/ConsumerDashboardBBPSpage?${queryString}`, '_blank');
              window.location.reload();
            }
            else {
              document.getElementById('spinner').style.display = 'none';
              document.getElementById('errorDiv').style.display = 'block';
              document.getElementById('errorMsg').innerHTML = parent.message[parseInt(status)];
              this.$bvModal.show("model");
              document.getElementById("modalMsg").innerHTML = parent.message[parseInt(status)];
              //document.getElementById("BillDetails").classList.remove("showBillDetails");
            }


          })
          .catch((e) => {
            parent.show = false;
            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML = "Sorry, Please Try Again Later";
            console.log("Caught :::::::::::::::", e.message);

          })
      }

    },
    downloadBillAssamese(consNo, billNo) {
        let dataDownload = {
        consNo: consNo,
        mobileNo: mobile,
        billNo: billNo,
        language: "assamese"
      };

      console.log(JSON.stringify(dataDownload))

      axios({
        method: 'post',
        url: this.$urlCommon + '/api/web/auth/postpaid/bill/download',
        headers: {
          'Authorization': accessToken,
          'Content-Type': 'application/json'
        },
        responseType: 'blob',   // IMPORTANT
        data: dataDownload
      })
        .then(response => {

          const blob = new Blob([response.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `Bill_${billNo}.pdf`;
          link.click();

        })
        .catch(error => {
          this.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML = "Unable to download bill";
          console.error(error);
        });
    },
    downloadBillEnglish(consNo, billNo) {
        let dataDownload = {
        consNo: consNo,
        mobileNo: mobile,
        billNo: billNo,
        language: "english"
      };

      axios({
        method: 'post',
        url: this.$urlCommon + '/api/web/auth/postpaid/bill/download',
        headers: {
          'Authorization': accessToken,
          'Content-Type': 'application/json'
        },
        responseType: 'blob',   // IMPORTANT
        data: dataDownload
      })
        .then(response => {
          console.log("response::::"+JSON.stringify(response.data))
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `Bill_${billNo}.pdf`;
          link.click();

        })
        .catch(error => {
          this.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML = "Unable to download bill";
          console.error(error);
        });
    },
    getBillHistory(action) {

      if ((action == "change") || (action == "click" && this.consumerBill.length == 0)) {
        var consNo = document.getElementById("consList").value;

        let data = JSON.stringify({
          "consNo": consNo,
          "mobileNo": mobile
        });

        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: this.$urlCommon + '/api/web/auth/billData',
          headers: {
            'Authorization': accessToken,
            'Content-Type': 'application/json'
          },
          data: data
        };

        this.show = true;
        var parent = this;
        axios.request(config)
          .then((response) => {

            this.show = false;
            var temp = [];
            response.data.billData.forEach(element => {
              var res1 = element.bill_DATE.split("-");
              var billDateFormatted = res1[2] + "/" + res1[1] + "/" + res1[0];
              var res2 = element.due_DATE.split("-");
              var dueDateFormatted = res2[2] + "/" + res2[1] + "/" + res2[0];
              var dueAmt = "";

              if (element.due_AMOUNT == 0) dueAmt = "Paid";
              else dueAmt = element.due_AMOUNT;
              let subdivision = consNo.substring(0, 3);
              let masked = 'x';

              var obj = {
                bill_no: element.bill_NO,
                bill_date: billDateFormatted,
                due_date: dueDateFormatted,
                due_amt: "<span style='padding-left:35%'>" + dueAmt + "<span>",
                net_amt: "<span style='padding-left:35%'>" + element.net_AMOUNT + "<span>",
                consNo: consNo   // 👈 required for download
              };
              temp.push(obj);
            })
            // console.log(temp)
            parent.consumerBill = temp
          })
          .catch((e) => {
            parent.show = false;
            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML = "Sorry, Please Try Again Later";
            console.log("Caught :::::::::::::::", e.message);

          })
      }
    },

    getPaymentHistory(action) {
      if ((action == "change") || (action == "click" && this.paymentHistory.length == 0)) {
        var consNo = document.getElementById("consList").value;
        let data = JSON.stringify({
          "consNo": consNo,
          "mobileNo": mobile
        });

        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: this.$urlCommon + '/api/web/auth/getPaymentReceipts',
          headers: {
            'Authorization': accessToken,
            'Content-Type': 'application/json'
          },
          data: data
        };

        this.show = true;
        var parent = this;
        axios.request(config)
          .then((response) => {
            //console.log(response.data);
            this.show = false;
            var data = response.data.receiptData;
            var temp = [];
            // data.forEach(element => {
            //   var res1 = element.payment_DATE.split("-");
            //   var paymentDateFormatted = res1[2] + "/" + res1[1] + "/" + res1[0];
            //   var obj = {
            //     "paid_bill_no": element.bill_NO,
            //     "payment_date": paymentDateFormatted,
            //     "payment_amt": element.paid_AMOUNT + ".00",
            //     "payment_mode": element.payment_MODE,
            //     "tr_id": element.receipt_NO,
            //     "view_receipt": "<a style='padding-left:40%' target='_blank' href='" + element.receiptlink + "'><img src='" + parent.$urlCommon + "/assets/pdf-icon-3.png' height='32px' width='32px'  /></a>"
            //   }
            //   temp.push(obj)

            // })
            data.forEach((element, index) => {
              var res1 = element.payment_DATE.split("-");
              var paymentDateFormatted = res1[2] + "/" + res1[1] + "/" + res1[0];
              const url = this.$urlCommon + '/api/web/auth/downloadPostpaidReceipt';
              let dataReceipt = JSON.stringify({
                "consNo": consNo,
                "mobileNo": mobile,
                "receiptNo": element.receipt_NO
              });
              var obj = {
                paid_bill_no: element.bill_NO,
                payment_date: paymentDateFormatted,
                payment_amt: element.paid_AMOUNT + ".00",
                payment_mode: element.payment_MODE,
                tr_id: element.receipt_NO,
                view_receipt: "",
                config2: {
                  method: 'post',
                  maxBodyLength: Infinity,
                  url: url,
                  headers: {
                    'Authorization': accessToken,
                    'Content-Type': 'application/json'
                  },
                  data: dataReceipt,
                  responseType: 'arraybuffer'
                }
              };
              temp.push(obj)

            })
            // console.log(temp)
            parent.paymentHistory = temp;

          })
          .catch((e) => {
            parent.show = false;
            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML = "Sorry, Please Try Again Later";
            console.log("Caught :::::::::::::::", e.message);

          })
      }
    },
    downloadReceipt(item) {
      if (!item) return alert("Invalid receipt");

      axios.request(item.config2)
        .then(response => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `Receipt_${item.tr_id}.pdf`;
          link.click();
          window.URL.revokeObjectURL(link.href);
        })
        .catch(error => {
          console.error("Download error:", error);
          alert("Failed to download receipt.");
        });
    },
    getConsumptionHistory(action) {

      if ((action == "change") || (action == "click" && this.consumptionHistory.length == 0)) {
        var chartData = [];
        var chartLabel = [];
        var consNo = document.getElementById("consList").value;



        let data = JSON.stringify({
          "consNo": consNo,
          "mobileNo": mobile
        });

        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: this.$urlCommon + '/api/web/auth/consumptionHistory',
          headers: {
            'Authorization': accessToken,
            'Content-Type': 'application/json'
          },
          data: data
        };

        this.show = true;
        var parent = this;
        axios.request(config)
          .then((response) => {

            //console.log(response.data);
            parent.show = false;
            var temp = [];
            response.data.response.forEach(element => {
              var res1 = element.meter_READING_DATE.split("-");
              var meterREADINGDATE = res1[2] + "/" + res1[1] + "/" + res1[0];

              var obj = {
                "meter_reading_date": meterREADINGDATE,
                "last_meter_reading": element.last_METER_READING,
                "consumption": element.consumption,
                "total_days": element.no_OF_DAYS,
              }
              temp.push(obj);
              chartData.push(element.consumption);
              chartLabel.push(meterREADINGDATE);

            })
            // console.log(temp)
            parent.consumptionHistory = temp;

            document.getElementById("chartContainer").innerHTML = '&nbsp;';
            document.getElementById("chartContainer").innerHTML = '<canvas id="consumptionChart"></canvas>';
            var ctx = document.getElementById('consumptionChart');
            var myChart = new Chart(ctx, {
              type: 'bar',
              data: {
                labels: chartLabel,
                datasets: [
                  {
                    label: "Consumption",
                    fill: true,
                    backgroundColor: [
                      '#ffab91',
                      '#ff8a65',
                      '#ff7043',
                      '#ff5722',
                      '#e64a19',
                      '#d84315'
                    ],
                    data: chartData
                  }
                ]
              },

              options: {
                responsive: true,
                lineTension: 1,
                scales: {
                  yAxes: [{
                    ticks: {
                      beginAtZero: true,
                      padding: 25,
                    }
                  }]
                }
              }
            });
          })
          .catch((e) => {
            parent.show = false;
            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML = "Sorry, Please Try Again Later";
            console.log("Caught :::::::::::::::", e.message);

          })
      }
    },
    showConsDetails(action) {

      if ((action == "change") || (action == "click" && this.consDetails.length == 0)) {

        var consNo = document.getElementById('consList').value;
        this.show = true;

        var parent = this;
        let data = JSON.stringify({
          "consNo": consNo,
          "mobileNo": mobile
        });

        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: this.$urlCommon + '/api/web/auth/getConsDetails',
          // url: 'https://www.apdcl.org/website/api/web/auth/getConsDetails',
          headers: {
            'Authorization': accessToken,
            'Content-Type': 'application/json'
          },
          data: data
        };

        let mapping = {
          method: 'post',
          url: this.$urlCommon + '/api/web/auth/getDistrictMapping?consNo=' + consNo,
          headers: {
            'Authorization': accessToken,
            'Content-Type': 'application/json'
          },
          data: data
        };

        var parent = this;

        axios.request(config)
          .then((response) => {
            parent.show = false;
            // console.log(response.data);

            if (response.data.message == "00") {
              var data = response.data;
              oldMob = data.mobile_no;
              document.getElementById("consumerNumber").innerHTML = data.cons_no;
              consumerNumberGlobal = data.cons_no;
              document.getElementById("consumerName").innerHTML = data.cons_name;
              consumerNameGlobal = data.cons_name;
              consumerAddressGlobal = data.cons_ADD1;
              document.getElementById("mobile").value = data.mobile_no;
              consumermobileGlobal = data.mobile_no;
              document.getElementById("email").value = data.email;
              subdivisionNameGlobal = data.subDivisionName;

              var distCode = data.district;
              var container = document.getElementById("districtContainer");

              if (!distCode || distCode.trim() === "") {
                this.districtFlag = true;
                axios.request(mapping)
                  .then(function (response) {
                    const districts = response.data;

                    let options = '<option value="">Please select a District</option>';
                    Object.entries(districts).forEach(([districtName, districtCode]) => {
                      options += `<option value="${districtName} - ${districtCode}">${districtName}</option>`;
                    });

                    container.innerHTML = `
                    <select class="form-control mb-3" id="districtDropdown">
                      ${options}
                    </select>
                  `;
                  })
                  .catch(function (error) {
                    console.error("Error fetching district mapping:", error);
                  });
              } else {
                var districtName = distCode.split(" - ")[0];
                var districtCode = distCode.split(" - ")[1];

                container.innerHTML = `
                <span id="districtName" data-code="${districtCode}">${districtName}</span>
              `;
              }

              parent.selected = data.occupation;
              // if (data.voter_ID== null || data.voter_ID=="")
              //    document.getElementById("voterId").placeholder = "Enter Voter No";
              // else
              //    document.getElementById("voterId").placeholder = data.voter_ID;
              parent.consDetails.push(data.cons_no);
            }
            else {
              parent.$bvModal.show('model');
              document.getElementById("modalMsg").innerHTML = "Consumer Not Found";
            }

          })
          .catch((e) => {

            parent.show = false;
            console.log("Caught", e.response.data.error);
            if (e.response.data.error == "Forbidden") {
              parent.$bvModal.show('redirectModal');
              document.getElementById("redirectModalMsg").innerHTML = "Session Expired, Please log in again";
            }
          })
      }
    },
    showNetConsDetails(action) {
      // console.log("inside Netcons");
      if ((action === "change") || (action === "click" && this.NetconsDetails.length == 0)) {
        var parent = this;
        this.show = true;
        this.checkAgreementStatus().then((isAgreementSubmitted) => {
          if (isAgreementSubmitted === "dataSubmitted") {
            this.showDataConfirmation();
          }
          else if (isAgreementSubmitted === "submitted") {

            this.showAgreementConfirmation();
          }
          else if (isAgreementSubmitted === "accepted") {

            this.showAgreementConfirmation();
          }
          else if (isAgreementSubmitted === "rejected") {

            //console.log("inside rejected method of shownetconsdetails");
            this.$bvModal.show('netAgreementrejectModal');
            //document.getElementById("rejectedModalMsg").innerHTML = "Your application has been rejected. Please update the details and re-submit.";
          }
          else {
            // this.showNetProfile = true; 
            document.getElementById("mainDiv").style.display = 'block';
            // Show net profile
            this.showAgreementProfile = false;
            this.showDataProfile = false;
            const consNo = document.getElementById('consList').value;
            // this.show = true;

            const data = JSON.stringify({
              "consNo": consNo,
              "mobileNo": mobile
            });
            const config = {
              method: 'post',
              maxBodyLength: Infinity,
              url: this.$urlCommon + '/api/web/auth/getConsDetails',
              headers: {
                'Authorization': accessToken,
                'Content-Type': 'application/json'
              },
              data: data
            };
            var parent = this;
            axios.request(config)
              .then((response) => {
                parent.show = false;
                //console.log("response.data.message::::", JSON.stringify(response.data.message));

                if (response.data.message === "00") {
                  const data = response.data;

                  this.oldMob = data.mobile_no;

                  // Populate form fields
                  this.NetsubDivisionName = data.subDivisionName;
                  subdivisionNameGlobal = data.subDivisionName;
                  // console.log("show net cons details subdivision name:", subdivisionNameGlobal);
                  document.getElementById("NetConsumerNumber").innerHTML = data.cons_no;
                  document.getElementById("NetConsumerName").innerHTML = data.cons_name;
                  document.getElementById("NetMobile").innerHTML = data.mobile_no;
                  document.getElementById("NetAddress").innerHTML = data.cons_ADD1;


                  this.NetConsumerName = data.cons_name;

                  this.NetAddress = data.cons_ADD1;
                  // consumerAddressGlobal = this.NetAddress;
                  sessionStorage.setItem('NetConsumerName', this.NetConsumerName); // Save to sessionStorage
                  sessionStorage.setItem('NetAddress', this.NetAddress);


                  this.consDetails.push(data.cons_no);

                } else {
                  this.$bvModal.show('model');
                  document.getElementById("modalMsg").innerHTML = "Consumer Not Found";
                }
              })
              .catch((e) => {
                this.show = false;
                //console.log("Caught", e.response.data.error);
                if (e.response.data.error === "Forbidden") {
                  this.$bvModal.show('redirectModal');
                  document.getElementById("redirectModalMsg").innerHTML = "Session Expired, Please log in again";
                }
              });



          }
        })
      }
    },


    async checkAgreementStatus() {
      let agreementStatus = null;
      const consNo = document.getElementById("consList").value;
      const mobile = sessionStorage.getItem("mobile");
      const dataToSearch = {
        consNo: consNo,
        mobileNo: mobile
      };

      const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: this.$urlCommon + '/api/web/auth/getAgreementData',
        headers: {
          'Authorization': accessToken,
          'Content-Type': 'application/json'
        },
        data: dataToSearch
      };

      try {
        const response = await axios.request(config);
        const len = response.data.length;
        // console.log ("len::"+len);


        if (response && response.data && response.data.length > 0) {
          const serverStatus = response.data[len - 1].agreement_status;
          const location = response.data[len - 1].location;
          if (serverStatus === "1" && location == "") {
            agreementStatus = "dataSubmitted";
            document.getElementById("showCommentNetData").innerHTML =
              'Your data has been uploaded successfully.';
          }
          else if (serverStatus === "1") {
            if (response.data[len - 1].sde_sig === "") {
              // console.log("inside status=1 (submitted)");
              agreementStatus = "submitted";
              document.getElementById("showComment").innerHTML =
                'Your document has been uploaded successfully. Please download your <span style="font-weight:bold; color:#d6602d">Provisional Agreement</span>.';
            }
          }

          else if (serverStatus === "2") {
            // console.log("inside status=2 (accepted)");
            agreementStatus = "accepted";
            document.getElementById("showComment").innerHTML =
              'Your document has been uploaded successfully. Please download your <span style="font-weight:bold; color:#d6602d">Final Agreement</span>.';
          }
          else if (serverStatus === "3") {
            // console.log("inside status=3 (rejected)");
            agreementStatus = "rejected";
          }
          else {
            // console.log("inside not submitted");
            agreementStatus = "not_submitted";
          }
        } else {
          console.log("No valid data received from server.");
          //agreementStatus = "not_submitted";
        }
      } catch (err) {
        console.error("Error calling server", err);

      }

      //console.log('agreementstatus:', agreementStatus);
      return agreementStatus;
    },
    showDataConfirmation() {
      this.show = false;
      this.showNetProfile = false;  // Hide the net metering profile
      this.showAgreementProfile = false; // Hide agreement profile
      this.showDataProfile = true;  // Show data profile
      this.activeContent = 'dataProfile';

    },
    showAgreementConfirmation() {
      this.show = false;
      this.showNetProfile = false;  // Hide the net metering profile
      this.showDataProfile = false; // Hide data profile
      this.showAgreementProfile = true;  // Show agreement profile
      this.activeContent = 'agreementProfile';

    },

    updateNetAgreement() {
      // console.log("inside updatenetagreement");
      this.show = false;
      this.$bvModal.hide('netAgreementrejectModal');
      this.showNetProfile = true;
      this.showAgreementProfile = false;
      this.showDataProfile = false;
      document.getElementById("mainDiv").style.display = 'block';

      this.NetConsumerNumber = consumerNumberGlobal;
      //this.NetConsumerName = sessionStorage.getItem('NetConsumerName') || this.NetConsumerName;
      this.NetConsumerName = consumerNameGlobal;
      this.NetAddress = consumerAddressGlobal;
      this.NetMobile = consumermobileGlobal;
      this.NetsubDivisionName = subdivisionNameGlobal;
      //this.NetAddress = sessionStorage.getItem('NetAddress') || this.NetAddress;
      //  console.log('Address',this.NetAddress );

      // console.log('consno',this.NetConsumerNumber );
      // console.log('consmobile',this.NetMobile );
      // console.log('NetsubDivisionName',this.NetsubDivisionName );

      document.getElementById("NetConsumerNumber").innerHTML = this.NetConsumerNumber;
      document.getElementById("NetConsumerName").innerHTML = this.NetConsumerName;
      document.getElementById("NetMobile").innerHTML = this.NetMobile;
      document.getElementById("NetAddress").innerHTML = this.NetAddress;

    },

    showAcceptAgreement() {
      if (this.isBeneficiary === 'YES') {
        if (this.validateBeneficiaryYes()) {
          this.submitBeneficiaryYes()
        }
      } else {
        if (this.validateBeneficiaryNo()) {
          this.submitBeneficiaryNo()
        }
      }
    },
    validateBeneficiaryYes() {
      if (!this.NetApplicationNo) {
        this.$bvToast.toast('Enter Application No!', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("NetApplicationNo").focus();
        return false
      }

      if (!this.NetApplDate) {
        this.$bvToast.toast('Enter Application Date!', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("NetApplDate").focus();
        return false
      }

      if (!this.NetCapacity || this.NetCapacity <= 0) {
        this.$bvToast.toast('Enter Installed Capacity!', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("NetCapacity").focus();
        return false
      }
      return true
    },
    submitBeneficiaryYes() {
      var consNo = document.getElementById("consList").value;
      var mobile = sessionStorage.getItem("mobile");
      const NetAdd = consumerAddressGlobal;
      const ConsName = consumerNameGlobal;
      const data = {
        consNo: consNo,
        applNo: this.NetApplicationNo,
        applDate: this.NetApplDate,
        consName: consumerNameGlobal,
        mobNo: mobile,
        mobileNo: mobile,
        address: consumerAddressGlobal,
        capacity: this.NetCapacity
      }

      var parent = this;
      parent.show = true;

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: this.$urlCommon + '/api/web/auth/savePmsgyData',
        headers: {
          'Authorization': accessToken,
          'Content-Type': 'application/json'
        },
        data: data
      };

      try {
        axios.request(config)
          .then(function (response) {
            parent.show = false;
            console.log("status:::" + JSON.stringify(response.data.status));

            if (response.data.status == "success") {
              parent.$bvModal.show('agreementSuccessModal');
            }
            else {
              parent.$bvModal.show('netAgreementfailureModal');
            }
          });
      } catch (error) {
        console.error("Error calling server", error);
      }
    },
    validateBeneficiaryNo() {
      if (!this.validateBeneficiaryYes()) return false

      if (!this.NetApplicationNo) {
        this.$bvToast.toast('Enter Application No!', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("NetApplicationNo").focus();
        return false
      }

      if (!this.NetApplDate) {
        this.$bvToast.toast('Enter Application Date!', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("NetApplDate").focus();
        return false
      }

      if (!this.NetCapacity || this.NetCapacity <= 0) {
        this.$bvToast.toast('Enter Installed Capacity!', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("NetCapacity").focus();
        return false
      }

      if (!this.NetLocation) {
        this.$bvToast.toast('Enter Location!', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("NetLocation").focus();
        return false
      }

      if (this.isBeneficiary === 'NO' && !this.NetWitness) {
        this.$bvToast.toast('Enter Witness Name!', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("NetWitness").focus();
        return false
      }

      if (this.isBeneficiary === 'NO' && !this.consumerSignatureImageUrl && ((!this.consumerSignatureFile) || (!this.isConsumerSignatureValid))) {
        this.$bvToast.toast('Consumer Signature is required!', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("consumerSignatureImageUrl").focus();
        return false
      }

      if (this.isBeneficiary === 'NO' && !this.witnessSignatureImageUrl && ((!this.witnessSignatureFile) || (!this.isWitnessSignatureValid))) {
        this.$bvToast.toast('Witness Signature is required!', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        });
        document.getElementById("witnessSignatureImageUrl").focus();
        return false
      }

      return true
    },
    submitBeneficiaryNo() {
      var currentDate = new Date();
      var formatcurrentdDate = currentDate.toLocaleDateString('en-GB');
      this.NetCurrentDate = formatcurrentdDate;
      this.NetConsumerName = consumerNameGlobal;
      this.NetConsumerNumber = consumerNumberGlobal;
      // Toggle visibility
      if (this.isBeneficiary === 'NO') {
        this.showNetProfile = false;  // Hide the net metering profile
        this.showDataProfile = false;
        this.showAgreementProfile = false;
        this.showAcceptDiv = true;   // Show the agreement form
        window.scrollTo(0, 0);
      }
      else {
        this.$bvModal.show('netAgreementfailureModal');
      }
    },
    async uploadSignature(type) {
      this.show = true;


      const file = type === "consumer" ? this.consumerSignatureFile : this.witnessSignatureFile;


      if (!file) {
        this.show = false;
        this.$bvToast.toast("Please select a file first!", {
          title: "Alert",
          variant: "danger",
          solid: true,
        });
        return;
      }

      // Validate file type (JPG/JPEG)
      const validTypes = ['image/jpeg'];
      if (!validTypes.includes(file.type)) {
        this.show = false; // Hide the spinner if validation fails
        this.$bvToast.toast("Only JPG or JPEG files are allowed.", {
          title: "Alert",
          variant: "danger",
          solid: true,
        });
        return;
      }

      // Validate file size (10KB to 50KB)
      const fileSizeKB = file.size / 1024;
      if (fileSizeKB < 10 || fileSizeKB > 50) {
        this.show = false; // Hide the spinner if validation fails
        this.$bvToast.toast("File size must be between 10KB and 50KB.", {
          title: "Alert",
          variant: "danger",
          solid: true,
        });
        return;
      }

      // Validate image dimensions (150x100)
      const img = new Image();
      await new Promise((resolve, reject) => {
        img.onload = () => {
          if (img.width !== 150 || img.height !== 100) {
            this.show = false; // Hide the spinner if dimensions are invalid
            this.$bvToast.toast("Image dimensions must be 150x100 pixels.", {
              title: "Alert",
              variant: "danger",
              solid: true,
            });
            reject("Invalid dimensions");
          } else {
            resolve(); // Valid dimensions
          }
        };
        img.onerror = () => reject("Image load error");

        // Trigger image load
        img.src = URL.createObjectURL(file);
      });

      // If validation is successful, proceed with the file upload
      const reader = new FileReader();

      reader.onload = (e) => {
        if (type === "consumer") {
          this.consumerSignatureImageUrl = e.target.result;
          this.isConsumerSignatureValid = true; // Set flag for validation
        } else if (type === "witness") {
          this.witnessSignatureImageUrl = e.target.result;
          this.isWitnessSignatureValid = true; // Set flag for validation
        }

        this.show = false; // Hide the spinner once the upload is complete

        this.$bvToast.toast("Signature uploaded successfully!", {
          title: "Success",
          variant: "success",
          solid: true,
        });
      };

      reader.onerror = () => {
        this.show = false; // Hide the spinner if an error occurs
        this.$bvToast.toast("Error uploading the signature.", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      };

      // Start reading the file as data URL
      reader.readAsDataURL(file);
    },

    showTdsAdjustment(action) {
      if ((action == "change") || (action == "click" && this.tdsAdjustment.length == 0)) {
        var consNo = document.getElementById("consList").value;
        var parent = this;
        this.show = true;

        let data = JSON.stringify({
          "consNo": consNo,
          "mobileNo": mobile
        });

        let config = {
          method: 'post',
          maxBodyLength: Infinity,
          url: this.$urlCommon + '/api/web/auth/tdsStatement',
          headers: {
            'Authorization': accessToken,
            'Content-Type': 'application/json'
          },
          data: data
        };

        this.show = true;
        var parent = this;
        axios.request(config)
          .then((response) => {

            //console.log(response.data);
            parent.show = false;
            var status = response.data.status;
            console.log("sts:::" + status);
            var data = response.data.tdsStatement;
            var temp = [];
            var i = 1;
            // if (status === "Success") {
            if (status === "Success" && data.length > 0) {
              // document.getElementById("tdsTable").style.display = "block";
              this.showTdsTable = true;
              document.getElementById("tdsSpan").style.display = "none";
              data.forEach(element => {
                // var res1= element.payment_DATE.split("-");
                // var paymentDateFormatted = res1[2]+"/"+res1[1]+"/"+res1[0];
                var processedDate = "---"
                if (element.processed_DATE != null)
                  processedDate = element.processed_DATE.split("T")[0];
                var uploadDate = "---"
                if (element.upload_DATE != null)
                  uploadDate = element.upload_DATE.split("T")[0];
                var obj = {
                  "sl_no": i++,
                  "cons_no": element.cons_NO,
                  "tan_no": element.tan_NO,
                  "bill_no": element.bill_NO,
                  "tds_amt": element.tds_AMT_DEDUCTED,
                  "challan_no": element.challan_NO,
                  "challan_date": element.challan_DATE,
                  "challan_amt": element.challan_AMT,
                  "upload_date": uploadDate,
                  "processed_flag": element.processed_FLAG,
                  "processed_date": processedDate,
                  "challan_link": "<a style='padding-left:40%' target='_blank' href='" + element.challan_LINK + "'><img src='" + parent.$urlCommon + "/assets/pdf-icon-3.png' height='32px' width='32px'  /></a>"
                }
                temp.push(obj);
              })

              parent.tdsAdjustment = temp;

            }
            else {
              // document.getElementById("tdsTable").style.display = "none";
              this.showTdsTable = false;
              document.getElementById("tdsSpan").style.display = "block";
              document.getElementById("tdsSpan").innerHTML = response.data.message;

            }


          })
          .catch((e) => {
            parent.show = false;
            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML = "Sorry, Please Try Again Later";
            console.log("Caught :::::::::::::::", e.message);

          })
      }
    },
    saveAgreement() {
      if (!this.undertakingAccepted) {
        this.$bvToast.toast("Please accept the declaration!", {
          title: "Alert",
          variant: "danger",
          solid: true,
        });
        document.getElementById("checkbox-1").focus();
        return;
      }

      const dta = this.NetApplDate;
      const formatdate = dta.split("-");
      const applDateFormatted = `${formatdate[2]}/${formatdate[1]}/${formatdate[0]}`;
      const subDivisionName = subdivisionNameGlobal;
      const witness = document.getElementById("NetWitness").value.trim();
      const location = document.getElementById("NetLocation").value.trim();
      const capacity = document.getElementById("NetCapacity").value.trim();
      const ConsName = consumerNameGlobal;
      const NetAdd = consumerAddressGlobal;
      const currDateFormatted = applDateFormatted;
      var consNo = document.getElementById("consList").value;
      var mobile = sessionStorage.getItem("mobile");
      var applNo = document.getElementById("NetApplicationNo").value;
      //  console.log('insidesaveagreement::: location',location);
      // console.log('Save Agreement subDivisionName:::', subDivisionName);
      //console.log('location',location);

      const dataToSend = {
        consNo: consNo,
        applNo: applNo,
        applDate: dta,
        consName: ConsName,
        address: NetAdd,
        capacity: capacity,
        witnessName: witness,
        mobNo: mobile,
        subName: subDivisionName,
        location: location
        //undertakingAccepted: this.undertakingAccepted,
        //currdate: currDateFormatted,
      };

      //console.log("datatosend::::"+JSON.stringify(dataToSend));

      // let witnessSignatureUrl = this.witnessSignatureImageUrl;  
      // let consumerSignatureUrl = this.consumerSignatureImageUrl;
      const consumerSignature = document.querySelector("#consumerSignatureUpload").files[0];
      const witnessSignature = document.querySelector("#witnessSignatureUpload").files[0];
      const formData = new FormData();
      formData.append("data", new Blob([JSON.stringify(dataToSend)], { type: "application/json" }));
      formData.append("consumerSig", consumerSignature);
      formData.append("witnessSig", witnessSignature);
      formData.append("consNo", consNo);
      formData.append("mobileNo", mobile);
      // Call the PDF generation function with the data
      //this.generatePdf(dataToSend);



      var parent = this;
      parent.show = true;
      document.getElementById('saveAgreementbutton').disabled = true;
      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: this.$urlCommon + '/api/web/auth/saveAgreementData',
        headers: {
          'Authorization': accessToken,
          'Content-Type': 'multipart/form-data'
        },
        data: formData
      };

      // console.log("config::::"+JSON.stringify(config));


      try {
        axios.request(config)
          .then(function (response) {
            parent.show = false;
            //console.log("status:::"+response.data.status);

            if (response.data.status == "success") {
              //   this.$bvToast.toast("Application submitted successfully!", {
              //   title: "Success",
              //   variant: "success",
              //   solid: true,
              // });

              parent.$bvModal.show('netAgreementsuccessModal');
              //parent.$bvModal.show('netAgreementrejectModal');
              //this.generatePdf(dataToSend);

            }

            else {
              parent.$bvModal.show('netAgreementfailureModal');


            }
            document.getElementById('saveAgreementbutton').disabled = false;
          });
      } catch (error) {
        console.error("Error calling server", error.message);
      }
    },


    /*setTimeout(() => {
      window.location.reload();
    }, 2000);*/


    generatePdf() {

      //console.log("inside generatePdf");

      var consNo = document.getElementById("consList").value;
      var mobile = sessionStorage.getItem("mobile");
      const dataToSearch = {
        consNo: consNo,
        mobileNo: mobile

      }
      const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: this.$urlCommon + '/api/web/auth/getAgreementData',
        headers: {
          'Authorization': accessToken,
          'Content-Type': 'application/json'
        },
        data: dataToSearch
      };
      this.show = true;
      var parent = this;
      axios.request(config)
        .then((response) => {
          parent.show = false;

          //console.log("response data:::"+JSON.stringify(response.data[0]));

          var len = response.data.length;
          var NetAdd = response.data[len - 1].address;
          var date = response.data[len - 1].appl_date;

          var subDivisionName = response.data[len - 1].subName;
          var witness = response.data[len - 1].witness_name;
          var location = response.data[len - 1].location;
          var capacity = response.data[len - 1].capacity.toFixed(2);
          var ConsName = response.data[len - 1].cons_name;
          var ConsNo = response.data[len - 1].cons_no;
          //var currentdate = new Date(); 
          //var  currDateFormatted = currentdate.toLocaleDateString('en-GB');
          var witnessSignatureUrl = response.data[len - 1].witness_sig;
          var consumerSignatureUrl = response.data[len - 1].cons_sig;
          var sdeSignatureUrl = response.data[len - 1].sde_sig;

          var sdeSignatureDate = response.data[len - 1].sde_sig_dt;
          var formatdate = sdeSignatureDate.split("-");
          var sdeSignatureDateformatted = formatdate[2] + "/" + formatdate[1] + "/" + formatdate[0];
          var conssigdate = response.data[len - 1].cons_sig_dt;
          var formatconssigdate = conssigdate.split("-");
          var conssigdateformatted = formatconssigdate[2] + "/" + formatconssigdate[1] + "/" + formatconssigdate[0];


          var docDefinition = {
            pageSize: 'A4',
            pageOrientation: 'portrait',
            content: [

              { text: 'NET METERING/EXIM metering Connection Agreement', style: 'header' },

              { text: '-'.repeat(150) },

              {
                text: [
                  'This Agreement is made and entered into at ', { text: location, style: 'boldText' }, ' Assam on this ',
                  { text: conssigdateformatted, style: 'boldText' },
                  ', between', 'The Eligible Consumer, by the name of  ',
                  { text: ConsName, style: 'boldText' },
                  { text: '(Consumer No:' },
                  { text: ConsNo, style: 'boldText' },
                  { text: ')' },
                  ', having premise at ',
                  { text: NetAdd, style: 'boldText' },
                  ', as first party.\n\n',
                  { text: 'AND', alignment: 'center' },
                  '\n\n',
                  { text: 'Assam Power Distribution Licensee', style: 'boldText' },
                  ' (herein after called as Discom) represented by  SDE  ',
                  { text: subDivisionName, style: 'boldText' }, ,
                  ', and having its registered office at ',
                  { text: 'Guwahati, Assam', style: 'boldText' },
                  ' as second party of the agreement.\n',
                  'Whereas, the eligible consumer has taken the responsibility to set up or facilitate the requisite Photovoltaic system of capacity ',
                  { text: capacity, style: 'boldText' },
                  ' KWp and sought connectivity to the Discoms under NET metering/ EXIM metering arrangement.\n',
                  'And whereas, the Discoms agrees to benefit the eligible consumer for the electricity generated from the grid Interactive SPV plant into the power system of Discoms as per conditions of the agreement and AERC (Grid Integrative Solar PV Systems) Regulations, 2019 as amended from time to time.\n\n',
                  { text: 'Both the parties hereby agree as follows:', style: 'boldText' }
                ], style: 'normalText'
              },

              { text: '1. Eligibility', style: 'agreementHeader' },


              { text: '1.1 Eligible consumer is required to be aware, in advance, of the standards and conditions that the system has to meet for being integrated into the grid/distribution system.', style: 'normalText' },
              { text: '1.2 Eligible consumer agrees that connection of Photovoltaic system to DISCOM\'s distribution system shall be bound by requirements of state Distribution Code and/or DISCOM\'s conditions of service. The grid shall continue to perform with specified reliability, security, and quality as per the Central Electricity Authority Technical Standards for Connectivity of Distributed Generated Resources Regulations, 2014 of the Central Electricity Authority as amended from time to time.', style: 'normalText' },
              { text: '1.3 The eligible consumer shall also agree to conform to the specifications and standards applicable to the solar PV systems as may be prescribed by the Ministry of New and Renewable Energy Sources, Govt. of India, from time to time.', style: 'normalText' },





              { text: '2. Technical and Interconnection Requirements', style: 'agreementHeader' },


              { text: '2.1 Eligible consumer agrees that he has installed or will install, prior to connection of the photovoltaic system to DISCOM\'s distribution system, an isolation device (both automatic and inbuilt within inverter and external manual relays) and agrees for the DISCOM to have access to and operation of this, if required, for repair and maintenance of the distribution system.', style: 'normalText' },
              { text: '2.2 Eligible consumer agrees that in case of a power outage on DISCOM\'s system, the photovoltaic system will shut down, unless special transfer and isolating capabilities have been installed on the photovoltaic system.', style: 'normalText' },
              { text: '2.3 All the equipment connected to the distribution system must be compliant with relevant international (IEEE/IEC) or Indian standards (BIS), and installations of electrical equipment must comply with Indian Electricity Rules, 1956, and Central Electricity Authority (Measures of Safety and Electricity Supply) Regulations, 2010.', style: 'normalText' },
              { text: '2.4 Eligible consumer agrees that DISCOM will specify the interface/inter-connection point and metering point.', style: 'normalText' },
              { text: '2.5 Eligible consumer agrees to adhere to the following power quality measures as per International or Indian standards and/or other such  measures provided by the Commission/DISCOM:', style: 'normalText' },





              { text: 'a. Harmonic current: Harmonic current injections from a generating station shall not exceed the limits specified in IEEE 519.', style: 'normalText' },
              { text: 'b. Synchronization: The photovoltaic system must be equipped with a grid frequency synchronization device.', style: 'normalText' },
              { text: 'c. Voltage: The voltage-operating window should minimize nuisance tripping and should be under operating range of  80%-110% of the nominal connected voltage. Beyond a clearing time of 2 seconds, the photovoltaic system must isolate itself from the grid.', style: 'normalText' },
              { text: 'd. Flicker: Operating of the photovoltaic system should not cause voltage flicker in excess of  the limits stated in the relavant sections of  IEC standards or  other equivalent Indian standards, if any.', style: 'normalText' },
              { text: 'e. Frequency: When the distribution system frequency deviates outside the specified conditions (50.5Hz on upper side and 47.5Hz on lower side) , the photovoltaic system should not energize the grid and should shift to island mode.', style: 'normalText' },
              { text: 'f. DC injection: The photovoltaic system should not inject DC power more than 0.5% of full-rated output at the interconnection point or 1%  rated inverter output current into distribution system under any operating conditions.', style: 'normalText' },
              { text: 'g. Power factor: When the output of the inverter  is greater than 50%, a lagging power factor of greater than 0.9 should operate.', style: 'normalText' },
              { text: 'h. Islanding and Disconnection: The photovoltaic system in the event of voltage or frequency variations must island/disconnected itself within IEC standard on stipulated period.', style: 'normalText' },
              { text: 'i. Overload and Overheat: : The inverter should have the facility to automatically switch off in case of overload or overheating and shall restart when normal conditions are restored.', style: 'normalText' },
              { text: 'j. Paralleling device:Paralleling device of Photovoltaic system shall be capable of withstanding 220% of the nominal voltage at the interconnection point..', style: 'normalText' },


              { text: '2.6	  Eligible consumer agrees to furnish all the data such as voltage, frequency, and. breaker, isolator position in his system, as and when required by the Discom. He may also try to provide facilities for online transfer of the operational data.', style: 'normalText' },
              { text: '2.7	  The Eligible consumer shall not use a “hybrid inverter” i.e., a ‘solar inverter’ provision of feeding power to the grid.', style: 'normalText' },

              { text: '3. Safety', style: 'agreementHeader' },

              { text: '3.1 Eligible consumer shall comply with the provisions of Central Electricity Authority (Measures Relating to Safety and Electricity Supply) Regulations 2010 and relevant provisions of the National Electrical Code, particularly those related to Solar PV installations.', style: 'normalText' },
              { text: '3.2 Eligible Consumer agrees that the design, installation, maintenance and operation of the photovoltaic system are performed in a manner conducive to the safety of the photovoltaic system as well as the Discom\'s distribution system.', style: 'normalText' },
              { text: '3.3 Due to DISCOM\'s obligation to maintain a safe and reliable distribution system, eligible consumer agrees that if it is determined by Discom that eligible consumer\'s photovoltaic system either causes damage to and or produces adverse effects affecting other distribution systems consumers or DISCOM\'s assets, eligible consumer will have to disconnect photovoltaic system immediately from the distribution system upon direction from the Discom and correct the problem at his own expense prior to a reconnection.', style: 'normalText' },


              { text: '4. Clearances and Approvals', style: 'agreementHeader' },


              { text: '4.1 The eligible consumer agrees to attain all the necessary approvals and clearances (environmental and grid connected related) before connecting the photovoltaic system to the distribution system.', style: 'normalText' },

              { text: '5. Access and Disconnection', style: 'agreementHeader' },

              { text: '5.1 DISCOM shall have access to metering equipment and disconnecting means of the photovoltaic system, both automatic and manual, at all times.', style: 'normalText' },
              { text: '5.2	In emergency or outage situation, where there is no access to a disconnecting means, both automatic and manual, such as a switch or breaker, Discom may disconnect service to the premise', style: 'normalText' },



              { text: '6. Liabilities', style: 'agreementHeader' },


              { text: '6.1	Eligible consumer and Discom will indemnify each other for damages or adverse effects from either party\'s negligence or intentional misconduct in the connection and operation of photovoltaic system or DISCOM\'s distribution system.', style: 'normalText' },
              { text: '6.2	Discom and eligible consumer will not be liable to each other for any loss of profit or revenues, business interruption losses, loss of contract or loss of goodwill, or for indirect, consequential, incidental or special damages, including, but not limited to, punitive or exemplary damages, whether any of the said liability, loss or damages arise in contract, or otherwise.', style: 'normalText' },
              { text: '6.3Discom shall be liable for delivery or realization by eligible consumer for any fiscal or other incentive provided by the central government.', style: 'normalText' },

              { text: '7. Commercial Settlement', style: 'agreementHeader' },

              { text: '7.1	All the commercial settlement under this agreement shall follow Regulations of Assam Electricity Regulatory Commission.', style: 'normalText' },




              { text: '8. Connection Costs', style: 'agreementHeader' },

              { text: '8.1	The eligible consumer shall bear all costs related to setting up of photovoltaic system including metering and interconnection costs. The eligible consumer agrees to pay the actual cost of modifications and upgrades to the distribution facilities required to connect photovoltaic system in case it is required.', style: 'normalText' },
              { text: '8.2	Cost for interconnection equipment including the isolators, meters etc. are also to be borne by the eligible consumer.', style: 'normalText' },


              { text: '9. Termination', style: 'agreementHeader' },


              { text: '9.1	The eligible consumer can terminate agreement at any time by providing Discom with 90 days prior notice.', style: 'normalText' },
              { text: '9.2 Discom has the right to terminate Agreement on 30 days prior written notice, if eligible consumer breaches a term of this Agreement and does not remedy the breach within 30 days of receiving written notice from Discom of the breach.', style: 'normalText' },
              { text: '9.3 Eligible consumer agrees that upon termination of this Agreement, he must disconnect the photovoltaic system from DISCOM\'s distribution system in a timely manner and to DISCOM\'s satisfaction', style: 'normalText' },



              {
                text: [
                  'I hereby undertake that I have taken the responsibility to set up or facilitate the requisite Photovoltaic system of capacity ', { text: capacity }, ' KWp and sought connectivity to the Discom under NET metering/ EXIM metering arrangement.',
                  'And whereas, the Discom agrees to benefit the eligible consumer for the electricity generated from the grid Interactive SPV plant into the power system of Discom as per conditions of the agreement and AERC (Grid Integrative Solar PV Systems) Regulations, 2019 as amended from time to time.',
                ],
                style: 'cursiveStyle',
              },

              { text: ['Date: ', { text: conssigdateformatted, style: 'boldText' }], style: 'normalText' },
              // { text: ['Place: ', { text:location, style: 'boldText' }], style: 'normalText' },
              { text: ['Consumer Name: ', { text: ConsName, style: 'boldText' }], style: 'normalText' },

              {
                text: [
                  'In the witness, where of Mr.',
                  { text: witness, style: 'boldText' },
                  ', for and on behalf of ',
                  { text: ConsName, style: 'boldText' },
                  ', and  SDE ',
                  { text: subDivisionName, style: 'boldText' },
                  'for and on behalf of',

                  { text: 'Assam Power Distribution Licensee ', style: 'boldText,underline' },
                  ' (Discom) agree to this agreement',
                ], style: 'cursiveStyle'
              },
              {
                table: {
                  widths: ['*', '*', '*'],
                  body: [
                    [
                      {
                        stack: [
                          { text: 'Consumer Signature:', style: 'boldText' },
                          {
                            image: `data:image/jpg;base64,${consumerSignatureUrl}`,
                            width: 70,
                            height: 30,
                            alignment: 'left'
                          },
                          { text: 'Date: ' + conssigdateformatted, style: 'normalText' }
                        ]
                      },
                      {
                        stack: [
                          { text: 'Witness Signature:', style: 'boldText' },
                          {
                            image: `data:image/jpg;base64,${witnessSignatureUrl}`,
                            width: 70,
                            height: 30,
                            alignment: 'left'
                          },
                          { text: 'Date: ' + conssigdateformatted, style: 'normalText' }
                        ]
                      },
                      {
                        stack: [
                          { text: 'SDO Signature:', style: 'boldText' },
                          sdeSignatureUrl ? {
                            stack: [
                              { image: `data:image/jpg;base64,${sdeSignatureUrl} `, width: 70, height: 30 },
                              { text: `Date: ${sdeSignatureDateformatted}`, style: 'normalText' }
                            ]
                          } : { text: 'Signature to be uploaded', style: 'normalText' }
                          /* { text: 'Date: ' + sdeSignatureDateformatted, style: 'normalText' }*/
                        ]
                      },
                    ]
                  ]
                },
                layout: 'noBorders'
              }


            ],
            footer: function (currentPage, pageCount) {
              return {
                text: "Page " + currentPage + ' of ' + pageCount, alignment: 'center', fontSize: 7
              }
            },

            styles: {
              ul: {
                margin: [0, 0, 0, 0],
                bulletColor: 'transparent', // Makes bullets invisible
              },
              header: {
                fontSize: 10,
                bold: true,
                alignment: 'center',
                margin: [0, 0, 0, 5]
              },
              heading: {
                fontSize: 10,
                bold: true,
                margin: [0, 0, 0, 5],
                decoration: 'underline'
              },
              normalText: {
                fontSize: 9,

                margin: [0, 5, 0, 5]
              },
              boldText: {
                fontSize: 9,
                bold: true,
                margin: [0, 5, 0, 5],
                decoration: 'underline'
              },
              removelist: {
                fontSize: 9,
                margin: [0, 5, 0, 5],
                listType: 'none'
              },
              cursiveStyle: {
                fontSize: 9,
                italics: true,
                margin: [0, 5, 0, 5]

              },
              agreementHeader: {
                fontSize: 9,
                bold: true,
                margin: [0, 10, 0, 5],
                listType: 'none'
              },
            },
          };

          // Generate  PDF 
          pdfMake.createPdf(docDefinition).open();
          pdfMake.createPdf(docDefinition).download("NetAgreement" + ".pdf");
          /*this.$bvToast.toast("Application submitted and Agreement generated successfully!", {
              title: "Success",
              variant: "success",
              solid: true,
            });
        */
          setTimeout(function () { window.location.reload(); }, 2000);




        })
        .catch((e) => {
          this.show = false;
          console.log("Caught", e.response.data.error);
          console.log("Error");

        });


      return;









    },


    updateConsumer() {

      //console.log("inside update consumer");
      var consNo = document.getElementById("consList").value;
      var mobNo = document.getElementById("mobile").value;
      var email = document.getElementById("email").value;
      var occupation = document.getElementById("occupation").value;
      // var voterId = document.getElementById("voterId").value;

      var mobregx = /^[5-9]\d{9}$/
      if (!mobregx.test(mobNo)) {
        // document.getElementById('failure-btn-mob').click();
        this.$bvToast.toast('Enter 10 Digit Valid Mobile Number !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        return
      }

      var emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      if (!emailRegex.test(email) && email != "") {
        // document.getElementById('failure-btn-mob').click();
        this.$bvToast.toast('Enter Valid Email !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })
        document.getElementById("email").focus();
        return
      }


      // var voterIdRegex = /^([a-zA-Z]){3}([0-9]){7}?$/g;
      // if(!voterIdRegex.test(voterId) && voterId != "" )
      //     {
      //       // document.getElementById('failure-btn-mob').click();
      //       this.$bvToast.toast('Enter Valid Voter ID !', {
      //         title: `Alert`,
      //         variant: 'danger',
      //         solid: true
      //       })
      //       document.getElementById("voterId").focus();
      //     return
      //     }

      let district = null;
      let districtCode = null;

      if (this.districtFlag === true) {
        // Case: selected from dropdown
        const selectedValue = document.getElementById('districtDropdown')?.value;

        if (selectedValue && selectedValue.includes(' - ')) {
          const [districtName, distCode] = selectedValue.split(' - ').map(s => s.trim());
          district = districtName;
          districtCode = distCode;
        } else {
          this.$bvToast.toast('Please select a district!', {
            title: 'Alert',
            variant: 'danger',
            solid: true
          });
          return;
        }
      } else {
        // Case: prefilled, get from span and attribute
        const districtSpan = document.getElementById('districtName');
        district = districtSpan?.innerText?.trim();
        districtCode = districtSpan?.getAttribute('data-code')?.trim();

        if (!district || !districtCode) {
          this.$bvToast.toast('District information is missing!', {
            title: 'Alert',
            variant: 'danger',
            solid: true
          });
          return;
        }
      }


      let data = JSON.stringify({
        "consNo": consNo,
        "email": email,
        "mobNo": mobNo,
        "occupation": occupation,
        "mobileNo": mobile,
        "district": district,
        "districtCode": districtCode
      });

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: this.$urlCommon + '/api/web/auth/updateConsumerDetails',
        headers: {
          'Authorization': accessToken,
          'Content-Type': 'application/json'
        },
        data: data
      };

      this.show = true;
      var parent = this;
      axios.request(config)
        .then((response) => {
          parent.show = false;
          var msg1 = response.data.status;
          if (msg1 == "success") {

            parent.$bvModal.show('profilesuccessModal');
          }
          else {

            parent.$bvModal.show('model');
            document.getElementById("modalMsg").innerHTML = response.data.message;
          }
        })
        .catch((e) => {
          parent.show = false;
          parent.$bvModal.show('model');
          document.getElementById("modalMsg").innerHTML = "Profile Update Failed";
          console.log("Caught :::::::::::::::", e.message);
        })
    }
  },


  mounted() {

    if (sessionStorage.getItem("accessToken")) {

      // document.getElementById("consNameMb").innerHTML=mobile;
      mobile = sessionStorage.getItem("mobile");
      accessToken = sessionStorage.getItem("accessToken");
      consList = JSON.parse(sessionStorage.getItem("consList"));
      //this.NetAddress = sessionStorage.getItem("NetAddress");
      //console.log("consList Length::::"+consList.length)

      if (parseInt(consList.length) > 0) {
        consList.forEach(element => {
          var option1 = document.createElement("option");
          option1.text = element;
          option1.value = element;
          var select1 = document.getElementById("consList");
          select1.appendChild(option1);
        })
        //parent.switchConsumer();
        document.getElementById("consList").value = sessionStorage.getItem("selectedCons");
        this.showConsDetails('change');

      }
      else {
        parent.$bvModal.show('model');
        document.getElementById("modalMsg").innerHTML = "No Consumer Mapped to This Mobile number";

      }
    }
    else {
      this.$router.push({ path: '/' })

    }
  }
}


</script>


<style scoped="true">
#loader {
  height: 100%;
  min-height: 100%;
  width: 100%;

}

.label {
  font-weight: 600;

}

.customSelect {

  border: 1px solid #039be5;
  color: #0277bd;
  border-radius: 5px;
  height: 1.8rem;
  width: 10rem;
  font-weight: 600;

}

.customSelect:hover {
  cursor: pointer;
  border: 2px solid #039be5;
  color: #1565c0;
  border-radius: 5px;
  height: 1.8rem;
  width: 10rem;
  font-weight: 600;
}

.modalFont {
  width: 100px;
  display: block;
  margin: 40px auto 0;
}

.path {
  stroke-dasharray: 1000;
  stroke-dashoffset: 0;
}

.path.circle {
  -webkit-animation: dash 0.9s ease-in-out;
  animation: dash 0.9s ease-in-out;
}

.path.line {
  stroke-dashoffset: 1000;
  -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
  animation: dash 0.9s 0.35s ease-in-out forwards;
}

.path.check {
  stroke-dashoffset: -100;
  -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
  animation: dash-check 0.9s 0.35s ease-in-out forwards;
}

p {
  text-align: center;
  margin: 20px 0 60px;
  font-size: 1.25em;
}

p.success {
  color: #73AF55;
}

p.error {
  color: #D06079;
}

.agreement {
  font-weight: 600;
  color: #263238;

}

.declaration {
  color: #263238;
  font-weight: 600;
  text-decoration: underline;
}

.decl {
  color: #263238;
  font-weight: 200;
  font-size: 14px;
}

.agreement-container {
  width: 98%;
  max-width: 1000px;
  margin: 20px auto;
  padding: 30px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border: 1px solid #ddd;
}

.agreement-content {
  height: 400px;
  overflow-y: auto;
  padding: 15px;
  line-height: 1.6;
  font-size: 14px;
  color: #333;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #f9f9f9;
}

.agreement-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}

.center {
  text-align: center;
  font-weight: bold;
}

.agreement h6 {
  margin-top: 20px;
  font-weight: bold;
  color: #007bff;
}

@-webkit-keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }

  100% {
    stroke-dashoffset: 0;
  }
}

@keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }

  100% {
    stroke-dashoffset: 0;
  }
}

@-webkit-keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }

  100% {
    stroke-dashoffset: 900;
  }
}

@keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }

  100% {
    stroke-dashoffset: 900;
  }
}

.headerF {
  display: block;
}

.headerM {
  display: none;
}

.OnlinePaymentCardStyle {
  padding: 0;
  box-shadow: rgba(0, 0, 0, 0.5) 3px 5px 16px -5px;
  width: 30%;
  margin-left: 35%;
  text-align: center;
  min-height: 50vh;
}

.marginTop {
  margin-top: -10px;
}

.marginTop20px {
  margin-top: none;
}

@media (max-width: 768px) {
  .headerF {
    display: none;
  }

  .headerM {
    display: block;
  }

  .OnlinePaymentCardStyle {
    width: 50%;
    margin-left: 25%;
  }

  .marginTop {
    margin-top: 20px;
  }

  .marginTop20px {
    margin-top: 20px;
  }
}

@media (max-width: 576px) {
  .OnlinePaymentCardStyle {
    width: 80%;
    margin-left: 10%;
  }

  .marginTop20px {
    margin-top: 20px;
  }
}
</style>
